import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, ListSubheader, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
// import Select from "@mui/material/Select";
import SearchIcon from '@mui/icons-material/Search';
import { saveAs } from 'file-saver';
import { useFormik } from "formik";
import jsPDF from 'jspdf';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import * as Yup from "yup";
import BasicTable from '../../../components/basicTable/basicTable';
import Map from '../../../components/maps/map';
import RemainingTime from '../../../components/time/remainingTime';
import { fetchPaginatedAllComplaints } from '../../../features/powerComplaints/getComplaintSlice';
import blue_Circle from '../../../images/blueCircle.png';
import callCenter from '../../../images/callcenter.png';
import cellIcon from '../../../images/cellicon.png';
import closeIconWhite from '../../../images/close_icon_white.png';
import eOpsLogo from '../../../images/eops.png';
import eopsIcons from '../../../images/eopsicon.png';
import nepraIcon from '../../../images/nepra.png';
import orange from '../../../images/orange_Circle.png';
import redCircle from '../../../images/red_circle.png';
import triangleoff from '../../../images/triangle-off.png';
import { cfpBaseUrl } from '../../../network/urls';
import { convertDate, convertDateYYYYMMDD, convertDatewithTime, getCompanyName, subdivisionName, toTitleCase, divisionName as getDivisionName, circleName as getCircleName } from '../../../services/Functions';
import { tableStyle } from '../../../style/common';

import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { fetchGeoJson } from '../../../features/geoJson/geoJson';
import { updateOC } from '../../../features/officeCodeForName/officeCodeForName';
import { updateHomeButton } from '../../../features/powerComplaints/homeButtonSlice';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.jpg";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import excel from '../../../images/excel.png';
import pdf from '../../../images/pdf.png';
import print from '../../../images/print.png';
import { internalIconStyles } from '../../../style/common';

import { fetchDivisionGeoJson } from '../../../features/geoJson/divisionGeoJson';
import pitcLogo from '../../../images/pitcLogo.png';
import { AllSubDivisionsForAdmin } from '../../../network/APIs/APIs';
import { Token } from '@mui/icons-material';
import { fetchAuth } from '../../../features/mdm/authorization';

const ComplaintsGIS = () => {

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const { home: homeButtonState } = useSelector(state => state.homeButton);
    const [dateFrom, setDateFrom] = useState(getCurrentDate())
    const [dateTo, setDateTo] = useState(getCurrentDate())
    const { code, hierarchy, token, permissions, name, roleName, userId, roleTypeId, circleCode: authCircleCode } = useSelector((state) => state.auth)
    const { data: mdmToken } = useSelector((state) => state.authorization);
    const tableRef = useRef(null);
    const dispatch = useDispatch();
    const { data: geoJSON, isLoading: geoJsonLoading } = useSelector((state) => state.geoJson)
    const { data: geoJSONDivision } = useSelector((state) => state.divisionGeoJson)
    const [subDivision, setSubDivision] = useState()
    const [connections, setConnections] = useState();
    // Complaints - don't cache in localStorage as data is too large
    const [complaints, setComplaints] = useState([])
    const [showComplaintForm, setShowComplaintForm] = useState(false);
    const [selectedOffice, setSelectedOffice] = useState('')
    const [showPendingComplaint, setShowPendingComplaint] = useState(false);
    const { wmsPrivateToken } = useSelector(state => state.auth)
    const [selectedLineman, setSelectedLineman] = useState('');
    const [userIds, setUserIds] = useState([]);
    const [companyUserIds, setCompanyUserIds] = useState([]);
    const [companyFieldStaff, setCompanyFieldStaff] = useState([]);
    const [linemanDetails, setLinemanDetails] = useState([]);
    const [onPressComplaint, setOnPressComplaint] = useState()
    const [Priority, setPriority] = useState("1")
    const [powerComplaintsToDataGrid, setPowerComplaintsToDataGrid] = useState([]);
    const [pendingComplaints, setPendingComplaints] = useState()
    const [allocatedComplaints, setAllocatedComplaints] = useState()
    const [workingComplaints, setWorkingComplaints] = useState()
    const [onholdComplaints, setOnHoldComplaints] = useState()
    const [escalatedComplaints, setEscalatedComplaints] = useState()
    const [resolvedComplaints, setResolvedComplaints] = useState()
    const [totalComplaints, setTotalComplaints] = useState()
    const [rowData, setRowData] = useState()
    const [pendingStats, setPendingStats] = useState()
    const [allocatedStats, setAllocatedStats] = useState()
    const [onholdStats, setOnholdStats] = useState()
    const [workingStats, setWorkingStats] = useState()
    // APMS Complaints State
    const [apmsComplaints, setApmsComplaints] = useState([])
    const [apmsPendingStats, setApmsPendingStats] = useState(0)
    const [apmsAllocatedStats, setApmsAllocatedStats] = useState(0)
    const [apmsOnholdStats, setApmsOnholdStats] = useState(0)
    const [selectedApmsComplaint, setSelectedApmsComplaint] = useState(null)
    const [showApmsPopup, setShowApmsPopup] = useState(false)
    const [apmsLineman, setApmsLineman] = useState('')
    const [apmsStatus, setApmsStatus] = useState('')
    const [apmsLinemanRemarks, setApmsLinemanRemarks] = useState('')
    const [apmsRemarksError, setApmsRemarksError] = useState('')
    const [showApmsSuccessDialog, setShowApmsSuccessDialog] = useState(false)
    const [apmsSuccessMessage, setApmsSuccessMessage] = useState('')
    const [escalatedStats, setEscalatedStats] = useState()
    const [resolvedStats, setResolvedStats] = useState()
    const [allComplaintsState, setAllComplaintsState] = useState([])
    const [pendingStatsDetail, setPendingStatsDetail] = useState()
    const [allocatedStatsDetail, setAllocatedStatsDetail] = useState()
    const [onholdStatsDetail, setOnholdStatsDetail] = useState()
    const [workingStatsDetail, setWorkingStatsDetail] = useState()
    const [escalatedStatsDetail, setEscalatedStatsDetail] = useState()
    const [resolvedStatsDetail, setResolvedStatsDetail] = useState()
    const [weatherData, setWeatherData] = useState({})
    const [showLinemanPanel, setShowLinemanPanel] = useState(false)
    const [showSummaryPanel, setShowSummaryPanel] = useState(false)
    const [showIdleLinemanPopup, setShowIdleLinemanPopup] = useState(false)
    const [idleLinemanSearch, setIdleLinemanSearch] = useState('')
    const [idleLinemanCircleFilter, setIdleLinemanCircleFilter] = useState('')
    const [idleLinemanDivisionFilter, setIdleLinemanDivisionFilter] = useState('')
    const [idleLinemanSubdivFilter, setIdleLinemanSubdivFilter] = useState('')
    const [allComplaintsStateDetail, setAllComplaintsStateDetail] = useState([])
    const [openComplaintPopup, setOpenComplaintPopup] = useState(false);
    const [multipleComplaints, setMultipleComplaints] = useState([]);
    const [editingRowId, setEditingRowId] = useState(null);
    const [complaintData, setComplaintData] = useState(false)
    const [isHovered, setIsHovered] = useState(false);
    const [checkEdit, setCheckEdit] = useState(false)
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const statsTableRef = useRef();
    const [statsValue, setStatsValue] = useState()
    const statusNames = [
        'Pending',
        'Allocated',
        'Onhold',
        'Escalated',
        'Resolved',
        'Total',
    ];
    const [status, setStatus] = useState("");
    const [remarkStatus, setRemarkStatus] = useState("");
    const [remarks, setRemarks] = useState([])
    const [otherComplaints, setOtherComplaints] = useState()
    const sortedComplaints = [...complaints]
        .sort((a, b) => {
            const statusOrder = ['VIP', 'Pending', 'Allocated', 'onhold', 'OnHold', 'Onhold'];
            const priorityA = statusOrder.indexOf(a.Status);
            const priorityB = statusOrder.indexOf(b.Status);

            if (priorityA === priorityB) {
                return new Date(b.RegisteredAt) - new Date(a.RegisteredAt);
            }
            return priorityA - priorityB;
        });
    const formatComplaintTime = (dateString) => {
        const dateObj = new Date(dateString);
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };
    const reversedPendingComplaints = sortedComplaints.filter(c => c.Status === 'Pending').reverse();
    const reversedAllocatedComplaints = sortedComplaints.filter(c => c.Status === 'Allocated').reverse();
    const reversedOnHoldComplaints = sortedComplaints.filter(c => c.Status === 'onhold' || c.Status === 'OnHold' || c.Status === 'Onhold').reverse();
    const otherComplaintsS = sortedComplaints.filter(c => !['Pending', 'Allocated', 'onhold', 'OnHold', 'Onhold'].includes(c.Status));
    const finalSortedComplaints = [
        ...reversedPendingComplaints,
        ...reversedAllocatedComplaints,
        ...reversedOnHoldComplaints,
        ...otherComplaintsS
    ];

    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [selectedMarker2, setSelectedMarker2] = useState(null);

    const [open, setOpen] = useState(false);
    const { data: result1 } = useSelector((state) => state.feederStatus)

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const [isLoading, setIsLoading] = useState(true);
    const [statsLoading, setStatsLoading] = useState(true);

    const yesterdayDate = yesterday.toISOString().split('T')[0];
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const [complaintNotFoundMessage, setComplaintNotFoundMessage] = useState('')
    const [SerachedTrackingId, setSerachedTrackingId] = useState('')
    const [openComplaintError, setOpenComplaintError] = useState(false);
    const [disco, setDisco] = useState("15");
    const discoRef = useRef("15");
    const { pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: complaintsSubDivisionCode, dateFrom: complaintsDateFrom, dateTo: complaintsDateTo } = useSelector((state) => state.allComplaints)
    const { data: allComplaints } = useSelector((state) => state.allComplaints)
    const [circleName, setCircleName] = useState()
    const [companyName, setCompanyName] = useState()
    const [divisionName, setDivisionName] = useState()
    const [circleCode, setCircleCode] = useState()
    const [companyCodee, setCompanyCodee] = useState()
    const [divisionCode, setDivisionCode] = useState()

    const [circleCodeData, setCircleCodeData] = useState()
    const [divisionCodeData, setDivisionCodeData] = useState()

    const handleOpenPopup = (item) => {
        setSelectedMarker(item);
        setPowerComplaintsToDataGrid('')
        setOnPressComplaint(item)
        if (hierarchy == 52) {
            setShowComplaintForm(true)
        }

    };

    // APMS Popup Handler
    const handleOpenApmsPopup = (item) => {
        setSelectedApmsComplaint(item);
        setShowApmsPopup(true);
    };

    const handleCloseApmsPopup = () => {
        setShowApmsPopup(false);
        setSelectedApmsComplaint(null);
        setApmsLineman('');
        setApmsStatus('');
        setApmsLinemanRemarks('');
        setApmsRemarksError('');
    };

    const handleClosePopup = () => {
        setOpen(false);
        setSelectedMarker(null);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedMarker(null);
    };

    let areaCode = ''
    if (hierarchy !== 52) {
        areaCode = '15171'
    } else {
        areaCode = code.slice(0, 5)
    }

    const currentDate = new Date();

    const getShiftIdByTime = () => {
        const currentTime = new Date();
        const hours = currentTime.getHours();

        if (hours >= 6 && hours < 14) {
            return 1;
        } else if (hours >= 14 && hours < 22) {
            return 2;
        } else {
            return 3;
        }
    };

    const filterLinemanByShift = (linemanData, shiftId) => {
        return linemanData.filter(lineman => lineman.shiftId === shiftId);
    };

    useEffect(() => {
        const getLineDataComplaints = async () => {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "officeCode": code
            });
            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };
            fetch(cfpBaseUrl + "workForce/getAllEmployeesList", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.data) {
                        const currentHour = new Date().getHours();

                        let currentShift;
                        if (currentHour >= 6 && currentHour < 14) {
                            currentShift = "1"; // Morning
                        } else if (currentHour >= 14 && currentHour < 22) {
                            currentShift = "2"; // Evening
                        } else {
                            currentShift = "3"; // Night
                        }

                        const filteredUsers = result.data.filter(user => {
                            const shiftIdsRaw = typeof user.shiftIds === "string" ? user.shiftIds : "";
                            const shiftIdsArray = shiftIdsRaw.replace(/\s+/g, "").split(",");

                            return shiftIdsArray.includes(currentShift);
                        });

                        setUserIds(filteredUsers);
                        setCompanyUserIds(filteredUsers);
                    }
                })
                .catch((error) => console.error(error));

        }
        getLineDataComplaints()

    }, [wmsPrivateToken])


    useEffect(() => {
        if (token) {
            const requestDisco = disco; // Capture disco at request time
            const getDataStats = async () => {
                const dateObject = new Date(currentDate);
                const formattedDate = dateObject.toISOString().split('T')[0];

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                // Use subDivision code if selected, otherwise use code
                // For admin users (code == 10 or roleTypeId == 1), use selected disco
                const subDivCodeToUse = subDivision || (roleTypeId == 1 || code == "10" || code == 10 ? disco : code);

                const raw = JSON.stringify({
                    "pageNumber": "1",
                    "pageSize": "99999",
                    "SubDivisionCode": subDivCodeToUse,
                    "dateFrom": "",
                    "dateTo": formattedDate
                });


                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow"
                };

                try {
                    const response = await fetch(cfpBaseUrl + "lineComplaints/getAllComplaintsForGISDashboard", requestOptions);
                    const result = await response.json();


                    let pendingComplaints = [];
                    let allocatedComplaints = [];
                    let workingComplaints = [];
                    let onholdComplaints = [];
                    let escalatedComplaints = [];
                    let resolvedComplaints = [];
                    let otherComplaints = [];
                    let totalComplaint = 0;
                    let allComplaints = [];

                    const formatComplaintTime = (dateString) => {
                        const dateObj = new Date(dateString);
                        const hours = String(dateObj.getHours()).padStart(2, '0');
                        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
                        return `${hours}:${minutes}`;
                    };


                    result.data.forEach(complaint => {
                        if (complaint.RegisteredAt) {
                            complaint.RegisteredAt = formatComplaintTime(complaint.RegisteredAt);
                        }
                        if (complaint.AllocationDateTime) {
                            complaint.AllocationDateTime = formatComplaintTime(complaint.AllocationDateTime);
                        }
                        if (complaint.ModificationDateTime) {
                            complaint.ModificationDateTime = formatComplaintTime(complaint.ModificationDateTime);
                        }

                        // Push complaint to the allComplaints array
                        allComplaints.push(complaint);

                        switch (complaint.Status) {
                            case 'Pending':
                                pendingComplaints.push(complaint);
                                break;
                            case 'Allocated':
                                allocatedComplaints.push(complaint);
                                break;
                            case 'Working':
                                workingComplaints.push(complaint);
                                break;
                            case 'onhold':
                                onholdComplaints.push(complaint);
                                break;
                            case 'Onhold':
                                onholdComplaints.push(complaint);
                                break;
                            case 'Escalated':
                                escalatedComplaints.push(complaint);
                                break;
                            case 'Resolved':
                                resolvedComplaints.push(complaint);
                                break;
                            default:
                                otherComplaints.push(complaint);
                                break;
                        }
                        totalComplaint++;
                    });

                    // Only set data if disco hasn't changed since request was made
                    if (roleTypeId == 1 && discoRef.current !== requestDisco) {
                        console.log('Ignoring stale complaints response');
                        return;
                    }

                    setPendingStatsDetail(pendingComplaints);
                    setAllocatedStatsDetail(allocatedComplaints);
                    setOnholdStatsDetail(onholdComplaints);
                    setEscalatedStatsDetail(escalatedComplaints);
                    setWorkingStatsDetail(workingComplaints);
                    setResolvedStatsDetail(resolvedComplaints);
                    setAllComplaintsStateDetail(allComplaints)

                    // Set complaints for Map markers (with Latitude/Longitude)
                    setComplaints(result.data);

                    // Update stats counts from the fetched data
                    setPendingStats(pendingComplaints.length);
                    setAllocatedStats(allocatedComplaints.length);
                    setOnholdStats(onholdComplaints.length);
                    setEscalatedStats(escalatedComplaints.length);
                    setWorkingStats(workingComplaints.length);
                    setResolvedStats(resolvedComplaints.length);
                    // Total excludes Closed and Reopen
                    setTotalComplaints(pendingComplaints.length + allocatedComplaints.length + onholdComplaints.length + escalatedComplaints.length + workingComplaints.length + resolvedComplaints.length);

                    setOtherComplaints(otherComplaints);


                } catch (error) {
                    console.error(error);
                }
            };

            getDataStats();
        }
    }, [token, subDivision, disco]);

    // Fetch APMS Complaints on initial load and listen for refresh events
    useEffect(() => {
        const fetchApmsComplaints = async () => {
            const dateObject = new Date();
            const formattedDate = dateObject.toISOString().split('T')[0];

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            // Only use valid subdivision code (5 digits)
            const subDivCodeToUse = subDivision || (code && String(code).length === 5 ? code : null);
            if (!subDivCodeToUse) return; // Don't call API without valid subdivision

            const raw = JSON.stringify({
                "pageNumber": "1",
                "pageSize": "100",
                "officeCode": subDivCodeToUse,
                "dateFrom": "",
                "dateTo": formattedDate,
                "status":""
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            try {
                const response = await fetch(cfpBaseUrl + "apms/getAllAPMSComplaint", requestOptions);
                const result = await response.json();

                if (result.status === "200" && result.data) {
                    setApmsComplaints(result.data);

                    // Calculate stats
                    const pending = result.data.filter(c => c.status === 'Pending').length;
                    const allocated = result.data.filter(c => c.status === 'Allocated').length;
                    const onhold = result.data.filter(c => c.status === 'Onhold' || c.status === 'OnHold' || c.status === 'onhold').length;

                    setApmsPendingStats(pending);
                    setApmsAllocatedStats(allocated);
                    setApmsOnholdStats(onhold);
                }
            } catch (error) {
                console.error("Error fetching APMS complaints:", error);
            }
        };

        // Initial fetch - only at subdivision level (5 digit code)
        const isSubdivisionLevel = subDivision || (code && String(code).length === 5);
        if (token && isSubdivisionLevel) {
            fetchApmsComplaints();
        }

        // Listen for APMS complaint submission event to refresh list
        const handleApmsComplaintSubmitted = () => {
            console.log("APMS complaint submitted event received - refreshing list");
            const isSubdivLevel = subDivision || (code && String(code).length === 5);
            if (token && isSubdivLevel) {
                fetchApmsComplaints();
            }
        };

        window.addEventListener('apmsComplaintSubmitted', handleApmsComplaintSubmitted);
        return () => {
            window.removeEventListener('apmsComplaintSubmitted', handleApmsComplaintSubmitted);
        };
    }, [token, subDivision, disco, code, roleTypeId]);

    const mapStatsFromApi = (items) => {
        const stats = {
            pending: 0,
            allocated: 0,
            working: 0,
            escalated: 0,
            resolved: 0,
            onhold: 0,
            // closed: 0
        };

        items.forEach(item => {
            const status = item.Status?.toLowerCase();
            const count = parseInt(item.TotalCount || 0);

            if (status.includes("pending")) stats.pending = count;
            if (status.includes("allocated")) stats.allocated = count;
            if (status.includes("working")) stats.working = count;
            if (status.includes("escalated")) stats.escalated = count;
            if (status.includes("resolved")) stats.resolved = count;
            if (status.includes("hold")) stats.onhold = count;
            // if (status.includes("closed")) stats.closed = count;
        });

        return {
            ...stats,
            total:
                stats.pending +
                stats.allocated +
                stats.working +
                stats.escalated +
                stats.resolved +
                stats.onhold
            // stats.closed
        };
    };



    const getDataStats = async (value) => {
        if (hierarchy == 2) {

        } else if (hierarchy == 52 || subDivision) {
            // Handle both hierarchy 52 and when subdivision is selected from other hierarchies
            setStatsValue(value);
            const dateObject = new Date(currentDate);
            const formattedDate = dateObject.toISOString().split('T')[0];

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            // Use subDivision code if available, otherwise use code
            const officeCodeToUse = subDivision || code;

            const raw = JSON.stringify({
                "officeCode": officeCodeToUse,
                "dateFrom": formattedDate,
                "dateTo": formattedDate
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(cfpBaseUrl + "lineComplaints/getComplaintCountStatusWiseHierarchical", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    const apiStats = mapStatsFromApi(result.data);

                    setPendingStats(apiStats.pending);
                    setAllocatedStats(apiStats.allocated);
                    setWorkingStats(apiStats.working);
                    setEscalatedStats(apiStats.escalated);
                    setResolvedStats(apiStats.resolved);
                    setOnholdStats(apiStats.onhold);
                    // setClosedStats(apiStats.closed);

                    setTotalComplaints(apiStats.total);
                })
                .catch((error) => console.error(error));
        }

    };


    const getAPMSCoordinates = async (mdmToken, areaCode) => {
        try {

            const myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("privatekey", mdmToken);

            const formdata = new FormData();
            formdata.append("organization_code", areaCode);

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };

            await fetch("https://api.mdm.pitc.com.pk/api/get_apms_status", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status) {
                        setConnections(result.data);
                    }
                })
                .catch((error) => console.error(error));

        } catch (error) {
            console.error('Error getting APMS coordinates:', error);
        }
    };

    // City mapping for weather based on region names
    const cityMapping = {
        // LESCO Circles
        'lahore city': 'Lahore',
        'lahore cantt': 'Lahore',
        'northern lahore': 'Lahore',
        'central lahore': 'Lahore',
        'eastern lahore': 'Lahore',
        'southern lahore': 'Lahore',
        'sheikhupura': 'Sheikhupura',
        'nankana': 'Nankana Sahib',
        'kasur': 'Kasur',
        'okara': 'Okara',
        // GEPCO Circles
        'gujranwala': 'Gujranwala',
        'sialkot': 'Sialkot',
        'gujrat': 'Gujrat',
        'mandi bahauddin': 'Mandi Bahauddin',
        'narowal': 'Narowal',
        'hafizabad': 'Hafizabad',
        // FESCO Circles
        'faisalabad': 'Faisalabad',
        'jhang': 'Jhang',
        'sargodha': 'Sargodha',
        'mianwali': 'Mianwali',
        'chiniot': 'Chiniot',
        'toba tek singh': 'Toba Tek Singh',
        // IESCO Circles
        'islamabad': 'Islamabad',
        'rawalpindi': 'Rawalpindi',
        'attock': 'Attock',
        'jhelum': 'Jhelum',
        'chakwal': 'Chakwal',
        // MEPCO Circles
        'multan': 'Multan',
        'bahawalpur': 'Bahawalpur',
        'dera ghazi khan': 'Dera Ghazi Khan',
        'd.g. khan': 'Dera Ghazi Khan',
        'dg khan': 'Dera Ghazi Khan',
        'sahiwal': 'Sahiwal',
        'vehari': 'Vehari',
        'khanewal': 'Khanewal',
        'muzaffargarh': 'Muzaffargarh',
        'rahim yar khan': 'Rahimyar Khan',
        'rahimyar khan': 'Rahimyar Khan',
        'bahawal nagar': 'Bahawalnagar',
        'bahawalnagar': 'Bahawalnagar',
        // Default fallback
        'default': 'Lahore'
    };

    // Function to get city name from region name
    const getCityFromRegion = (regionName) => {
        if (!regionName) return 'Lahore';
        const lowerName = regionName.toLowerCase().trim();

        // Check direct match
        if (cityMapping[lowerName]) return cityMapping[lowerName];

        // Check partial match
        for (const [key, value] of Object.entries(cityMapping)) {
            if (lowerName.includes(key) || key.includes(lowerName)) {
                return value;
            }
        }

        // Return the region name as city (might work for major cities)
        return regionName;
    };

    // Fetch weather for a city
    const fetchWeather = async (cityName, regionCode) => {
        try {
            const apiKey = process.env.REACT_APP_WEATHER_API_KEY || '4d8fb5b93d4af21d66a2948710284366';
            const response = await fetch(
                `https://api.openweathermap.org/data/2.5/weather?q=${cityName},PK&units=metric&appid=${apiKey}`
            );
            const data = await response.json();

            if (data.cod === 200) {
                setWeatherData(prev => ({
                    ...prev,
                    [regionCode]: {
                        temp: Math.round(data.main.temp),
                        description: data.weather[0].description,
                        icon: data.weather[0].icon,
                        humidity: data.main.humidity,
                        windSpeed: data.wind.speed
                    }
                }));
            }
        } catch (error) {
            console.error('Weather fetch error:', error);
        }
    };

    useEffect(() => {
        // Only fetch APMS data when hierarchy is 52 (subdivision level)
        if (hierarchy == 52 && mdmToken) {
            getAPMSCoordinates(mdmToken?.privatekey, areaCode)

            const intervalId = setInterval(() => {
                getAPMSCoordinates(mdmToken?.privatekey, areaCode);
            }, 180000); // 3 minutes

            return () => clearInterval(intervalId);
        }
    }, [hierarchy, mdmToken])



    useEffect(() => {
        if (hierarchy == 52) {
            setStatsLoading(true);
        }
        dispatch(fetchAuth())
        dispatch(fetchPaginatedAllComplaints({
            pageSize: complaintsPageSize,
            pageNumber: complaintsPageNumber,
            subDivisionCode: code,
            dateFrom: convertDateYYYYMMDD(yesterdayDate),
            dateTo: convertDateYYYYMMDD(new Date())
        }));

        const intervalId = setInterval(() => {
            dispatch(fetchPaginatedAllComplaints({
                pageSize: complaintsPageSize,
                pageNumber: complaintsPageNumber,
                subDivisionCode: code,
                dateFrom: convertDateYYYYMMDD(yesterdayDate),
                dateTo: convertDateYYYYMMDD(new Date())
            }));
            getData();
            getFieldStaffCoordinates()
        }, 180000); // 3 minutes

        return () => clearInterval(intervalId);
    }, []);

    // Auto-refresh complaints and stats when subdivision is selected (for hierarchy 1,2,3,4 drill down)
    useEffect(() => {
        if (subDivision && hierarchy != 52) {
            const dateObject = new Date(currentDate);
            const formattedDate = dateObject.toISOString().split('T')[0];

            // Function to fetch stats for selected subdivision
            const fetchSubdivisionStats = async () => {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    "officeCode": subDivision,
                    "dateFrom": formattedDate,
                    "dateTo": formattedDate
                });

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow"
                };

                try {
                    const response = await fetch(cfpBaseUrl + "lineComplaints/getComplaintCountStatusWiseHierarchical", requestOptions);
                    const result = await response.json();
                    if (result.data) {
                        const apiStats = mapStatsFromApi(result.data);
                        setPendingStats(apiStats.pending);
                        setAllocatedStats(apiStats.allocated);
                        setWorkingStats(apiStats.working);
                        setEscalatedStats(apiStats.escalated);
                        setResolvedStats(apiStats.resolved);
                        setOnholdStats(apiStats.onhold);
                        setTotalComplaints(apiStats.total);
                    }
                } catch (error) {
                    console.error('Error fetching subdivision stats:', error);
                }
            };

            // Fetch complaints for selected subdivision
            dispatch(fetchPaginatedAllComplaints({
                pageSize: complaintsPageSize,
                pageNumber: complaintsPageNumber,
                subDivisionCode: subDivision,
                dateFrom: convertDateYYYYMMDD(yesterdayDate),
                dateTo: convertDateYYYYMMDD(new Date())
            }));

            // Fetch stats immediately
            fetchSubdivisionStats();

            // Set up interval for auto-refresh
            const intervalId = setInterval(() => {
                dispatch(fetchPaginatedAllComplaints({
                    pageSize: complaintsPageSize,
                    pageNumber: complaintsPageNumber,
                    subDivisionCode: subDivision,
                    dateFrom: convertDateYYYYMMDD(yesterdayDate),
                    dateTo: convertDateYYYYMMDD(new Date())
                }));
                fetchSubdivisionStats();
            }, 60000); // Refresh every 60 seconds

            return () => clearInterval(intervalId);
        }
    }, [subDivision]);

    const handleSubmit = (complaint) => {
        setSelectedMarker(complaint)
        if (hierarchy == 52) {
            setShowComplaintForm(true)
        }
    }

    useEffect(() => {
    }, [connections]);


    const tblColumns = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "AllocationDateTime", headerName: 'Registered At', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintDescription", headerName: 'Complaint Description', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Status", headerName: 'Status', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ]

    const tblPendingComplaints = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RefNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RegisteredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle }, // Updated alignment
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ];

    const tblAllocatedComplaints = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RefNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RegisteredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "UserFullName", headerName: 'Assigned to', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

        { field: "AllocationDateTime", headerName: 'Assigned @', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ]

    const tblOnHoldComplaints = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RefNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RegisteredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "LinemanRemarks", headerName: 'Holding Reason', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ]

    const tblEscalatedComplaints = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RefNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RegisteredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "EscalatedTo", headerName: 'Escalated to', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    const tblResolvedComplaints = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RefNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RegisteredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "UserFullName", headerName: 'Resolved By', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ModificationDateTime", headerName: 'Resolved Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    const tblWorkingComplaints = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RefNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RegisteredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ModificationDateTime", headerName: 'Last Modification Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    const tblTotalComplaints = [
        { field: "EOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RefNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "RegisteredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "Address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ComplaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "ModificationDateTime", headerName: 'Last Modification Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    useEffect(() => {
        const getUserWithAllocatedComplaintsBySubDivision = async () => {


            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", token);

            const raw = JSON.stringify({
                "SubdivisionCode": hierarchy === 52 ? code : "15171"
            });


            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };
            await fetch(cfpBaseUrl + "lineComplaints/getUserWithAllocatedComplaintsBySubDivision", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setLinemanDetails(result.data)
                })
                .catch((error) => console.error(error));
        }
        getUserWithAllocatedComplaintsBySubDivision()
    }, [])

    const handleLinemanChange = (event) => {
        setSelectedLineman(event.target.value);
    };


    const handlePriority = (event) => {
        setPriority(event.target.value);
    };
    const onClose = () => {
        setShowComplaintForm(false)
        setPowerComplaintsToDataGrid([]);
    }

    const onPressClosePending = () => {
        setShowPendingComplaint(false)
    }
    const handleComplaintsFromChild = (complaints) => {
        setOnPressComplaint(complaints)
    };

    const handleSubmitAssign = async () => {
        // Capture values before any state changes
        const currentStatus = selectedMarker?.Status;
        const currentEOpsTrackingId = selectedMarker?.EOpsTrackingId;

        if (!currentEOpsTrackingId) return;

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "EOpsTrackingId": currentEOpsTrackingId,
            "AllocatedTo": selectedLineman,
            "AllocatedBy": userId,
            "Remarks": "Allocated to Lineman.",
            "Priority": Priority
        });

        // Optimistic update - update stats immediately
        updateStatsOptimistically(currentStatus, 'Allocated');
        updateParentDataOptimistically(currentStatus, 'Allocated');

        // Optimistic update - update complaints list immediately
        let index = complaints.findIndex(item => item.EOpsTrackingId === currentEOpsTrackingId);
        if (index !== -1) {
            const updatedComplaints = [...complaints];
            updatedComplaints[index] = {
                ...updatedComplaints[index],
                Status: 'Allocated',
            };
            setComplaints(updatedComplaints);
        }

        setViewBackdrop(true);
        setShowComplaintForm(false);
        setSelectedMarker("");

        try {
            const response = await fetch(cfpBaseUrl + "lineComplaints/compaintAllocation", {
                method: "POST",
                headers: myHeaders,
                body: raw,
            });

            const result = await response.json();
            if (result) {
                setApmsSuccessMessage('Complaint allocated successfully');
                setShowApmsSuccessDialog(true);
            }

            // API call to sync actual data (will update stats from server response)
            dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: code, dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))

            setViewBackdrop(false);

        } catch (error) {
            console.error('Error:', error);
            setViewBackdrop(false);
        }
        setViewBackdrop(false)

    };

    const handleSubmitResume = async () => {
        const currentStatus = selectedMarker?.Status;
        const currentEOpsTrackingId = selectedMarker?.EOpsTrackingId;
        const newStatus = selectedMarker?.ModifiedBy?.startsWith('CCMS') ? 'Pending' : 'Allocated';


        console.log("Resuming complaint ID:", selectedMarker);
        if (!currentEOpsTrackingId) return;

        updateStatsOptimistically(currentStatus, newStatus);
        updateParentDataOptimistically(currentStatus, newStatus);

        // Optimistic update - update complaints list immediately
        let index = complaints.findIndex(item => item.EOpsTrackingId === currentEOpsTrackingId);

        console.log("Index found for resume:", index);
        if (index !== -1) {
            const updatedComplaints = [...complaints];
            updatedComplaints[index] = {
                ...updatedComplaints[index],
                Status: newStatus,
            };
            setComplaints(updatedComplaints);
        }

        setViewBackdrop(true);
        setShowComplaintForm(false);
        setSelectedMarker("");

        const myHeaders = new Headers();

        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "TicketNo": "",
            "EOpsTrackingId": currentEOpsTrackingId,
            "Status": newStatus,
            "LinemanRemarks": otherComments,
            "LinemanAudioRemarks": "",
            "LinemanImageRemarks": "",
            "ModifiedBy": userId,
            "StartTime": "",
            "EndTime": ""
        });

        const requestOptions = {
            method: "PUT",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        await fetch(cfpBaseUrl + "lineComplaints/updateStatusWMS", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.message == 'Status updated successfully.') {
                    setViewBackdrop(false)
                    setApmsSuccessMessage('Complaint resumed successfully');
                    setShowApmsSuccessDialog(true);
                    dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: hierarchy == 52 ? code : '15171', dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))
                }
            })
            .catch((error) => console.error(error));
    };


    useEffect(() => {
        if (allComplaints && allComplaints.length > 0) {
            setComplaints(allComplaints);
            // Note: Not caching complaints to localStorage - data is too large (QuotaExceededError)
            // For hierarchy 52, stop loading when complaints are loaded
            if (hierarchy == 52) {
                setIsLoading(false);
                setStatsLoading(false);
            }

            const pendingComplaintsArr = allComplaints.filter(
                complaint => (complaint.Status == 'Pending')
            );

            setPendingComplaints(pendingComplaintsArr.length);

            const allocatedComplaintsArr = allComplaints.filter(
                complaint => (complaint.Status === 'Allocated')
            );
            setAllocatedComplaints(allocatedComplaintsArr.length);

            const workingComplaintsArr = allComplaints.filter(
                complaint => ((complaint.Status === 'Working' || complaint.Status === 'Resume'))
            );
            setWorkingComplaints(workingComplaintsArr.length);

            const onholdComplaintsArr = allComplaints.filter(
                complaint => ((complaint.Status === 'Onhold' || complaint.Status === 'onhold'))
            );
            setOnHoldComplaints(onholdComplaintsArr.length);

            const escalatedComplaintsArr = allComplaints.filter(
                complaint => (complaint.Status === 'Escalated')
            );
            setEscalatedComplaints(escalatedComplaintsArr.length);

            const resolvedComplaintsArr = allComplaints.filter(
                complaint => ((complaint.Status === 'Resolved' || complaint.Status === 'resolved'))
            );
            setResolvedComplaints(resolvedComplaintsArr.length);

            // Update bottom bar stats when at subdivision level
            // Only update stats from allComplaints if:
            // 1. User is hierarchy 52 (subdivision level user), OR
            // 2. subDivision is set AND the complaints data is actually for that subdivision
            const complaintsMatchSubdivision = subDivision && complaintsSubDivisionCode &&
                complaintsSubDivisionCode.toString() === subDivision.toString();

            if (hierarchy == 52 || complaintsMatchSubdivision) {
                console.log("useEffect updating stats from allComplaints - subDivision:", subDivision, "complaintsSubDivisionCode:", complaintsSubDivisionCode);
                setPendingStats(pendingComplaintsArr.length);
                setAllocatedStats(allocatedComplaintsArr.length);
                setWorkingStats(workingComplaintsArr.length);
                setOnholdStats(onholdComplaintsArr.length);
                setEscalatedStats(escalatedComplaintsArr.length);
                setResolvedStats(resolvedComplaintsArr.length);
                // Total excludes Closed and Reopen
                setTotalComplaints(pendingComplaintsArr.length + allocatedComplaintsArr.length + workingComplaintsArr.length + onholdComplaintsArr.length + escalatedComplaintsArr.length + resolvedComplaintsArr.length);
            }
        } else if (hierarchy == 52) {
            // If allComplaints is null/undefined but hierarchy is 52, still stop loading
            setIsLoading(false);
            setStatsLoading(false);
        }
    }, [allComplaints, hierarchy, subDivision, complaintsSubDivisionCode])

    const onRemarkTypeChange = (value) => {
        setRemarkStatus(value);

    };

    const groupedRemarks = (remarks || []).reduce((acc, curr) => {
        if (curr && curr.ComplaintCategory) {
            const category = curr.ComplaintCategory;
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(curr.NatureOfComplaint);
        }
        return acc;
    }, {});

    const dropdownItems = Object.entries(groupedRemarks).flatMap(([category, complaints]) => [
        <ListSubheader key={category} sx={{ fontWeight: "500", fontSize: "18px", color: 'black' }}>
            {category}
        </ListSubheader>,
        ...complaints.map((complaint, index) => (
            <MenuItem key={`${category}-${index}`} value={complaint} sx={{ fontSize: "14px" }}>
                {complaint}
            </MenuItem>
        )),
    ]);

    const companyCode = code.slice(0, 2)
    const getLogo = (code) => {
        switch (code) {
            case '10':
                return pitcLogo
            case '11':
                return LESCOLOGO
            case '12':
                return GEPCOLOGO
            case '13':
                return FESCOLOGO
            case '14':
                return IESCOLOGO
            case '15':
                return MEPCOLOGO
            case '16':
                return PESCOLOGO
            case '27':
                return SEPCOLOGO
            case '37':
                return HESCOLOGO
            case '48':
                return QESCOLOGO
            case '59':
                return TESCOLOGO
            default:
                return MEPCOLOGO
        }
    }
    const getCompanies = (code) => {
        switch (code) {
            case '10':
                return "Power Information Technology Company"
            case '11':
                return "Lahore Electric Supply Company"
            case '12':
                return "Gujranwala Electric Power Company"
            case '13':
                return "Faisalabad Electric Supply Company"
            case '14':
                return "Islamabad Electric Supply Company"
            case '15':
                return "Multan Electric Power Company"
            case '16':
                return "Peshawar Electric Supply Company"
            case '27':
                return "Sukkur Electric Power Company"
            case '37':
                return "Hyderabad Electric Supply Company"
            case '48':
                return "Quetta Electric Supply Company"
            case '59':
                return "Tribal Electric Supply Company"
            default:
                return "Multan Electric Power Company"
        }
    }


    const DownloadPdf = async (print) => {
        let dateToPrint = convertDate(new Date());
        return new Promise((resolve, reject) => {
            const headers = ['Complaint ID', 'Ref No.', 'Time', 'Name', 'Address', 'Complaint Type'];
            const headers1 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Assigned to", "Assigned @"];
            const headers2 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Holding Reason"];
            const headers3 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Escalated To"];
            const headers4 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Resolved By", "Resolved Time"];
            const headers5 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Last Modification Time"];

            const complaintsData =
                statsValue == '1' ? pendingStatsDetail :
                    statsValue == '2' ? allocatedStatsDetail :
                        statsValue == '3' ? onholdStatsDetail :
                            statsValue == '4' ? escalatedStatsDetail :
                                statsValue == '5' ? resolvedStatsDetail :
                                    statsValue == '6' ? allComplaintsStateDetail :
                                        statsValue == '7' ? workingStatsDetail : [];
            ;

            if (!Array.isArray(complaintsData)) {
                console.error("complaintsData is not an array or is undefined.");
                return;
            }

            // Create table body
            const body = complaintsData.map(row => [
                row.EOpsTrackingId,
                row.RefNo,
                row.RegisteredAt,
                row.Name,
                row.Address,
                row.ComplaintType
            ]);

            const body1 = complaintsData.map(row => [
                row.EOpsTrackingId,
                row.RefNo,
                row.RegisteredAt,
                row.Name,
                row.Address,
                row.ComplaintType,
                row.UserFullName,
                row.AllocationDateTime
            ]);
            const body2 = complaintsData.map(row => [
                row.EOpsTrackingId,
                row.RefNo,
                row.RegisteredAt,
                row.Name,
                row.Address,
                row.ComplaintType,
                row.LinemanRemarks
            ]);
            const body3 = complaintsData.map(row => [
                row.EOpsTrackingId,
                row.RefNo,
                row.RegisteredAt,
                row.Name,
                row.Address,
                row.ComplaintType,
                row.EscalatedTo
            ]);
            const body4 = complaintsData.map(row => [
                row.EOpsTrackingId,
                row.RefNo,
                row.RegisteredAt,
                row.Name,
                row.Address,
                row.ComplaintType,
                row.UserFullName,
                row.ModificationDateTime
            ]);

            const body5 = complaintsData.map(row => [
                row.EOpsTrackingId,
                row.RefNo,
                row.RegisteredAt,
                row.Name,
                row.Address,
                row.ComplaintType,
                row.ModificationDateTime
            ]);
            const body6 = complaintsData.map(row => [
                row.EOpsTrackingId,
                row.RefNo,
                row.RegisteredAt,
                row.Name,
                row.Address,
                row.ComplaintType,
                row.ModificationDateTime
            ]);
            const columnStyles = statsValue == '1' ? {
                0: { cellWidth: 45 },
                1: { cellWidth: 45 },
                2: { cellWidth: 40 },
                3: { cellWidth: 40 },
                4: { cellWidth: 60 },
                5: { cellWidth: 40 },
            } : statsValue == '2' ? {
                0: { cellWidth: 40 },
                1: { cellWidth: 30 },
                2: { cellWidth: 20 },
                3: { cellWidth: 35 },
                4: { cellWidth: 60 },
                5: { cellWidth: 34 },
                6: { cellWidth: 30 },
                7: { cellWidth: 20 },
            } : statsValue == '3' ? {
                0: { cellWidth: 35 },
                1: { cellWidth: 30 },
                2: { cellWidth: 15 },
                3: { cellWidth: 42 },
                4: { cellWidth: 60 },
                5: { cellWidth: 35 },
                6: { cellWidth: 50 },
            } : statsValue == '4' ? {
                0: { cellWidth: 35 },
                1: { cellWidth: 30 },
                2: { cellWidth: 20 },
                3: { cellWidth: 42 },
                4: { cellWidth: 60 },
                5: { cellWidth: 30 },
                6: { cellWidth: 50 },
            } : statsValue == '5' ? {
                0: { cellWidth: 32 },
                1: { cellWidth: 26 },
                2: { cellWidth: 17 },
                3: { cellWidth: 42 },
                4: { cellWidth: 60 },
                5: { cellWidth: 30 },
                6: { cellWidth: 30 },
                7: { cellWidth: 30 },
            } : statsValue == '6' ? {
                0: { cellWidth: 35 },
                1: { cellWidth: 30 },
                2: { cellWidth: 20 },
                3: { cellWidth: 45 },
                4: { cellWidth: 64 },
                5: { cellWidth: 40 },
                6: { cellWidth: 35 },
            } : statsValue == '7' ? {
                0: { cellWidth: 35 },
                1: { cellWidth: 30 },
                2: { cellWidth: 20 },
                3: { cellWidth: 38 },
                4: { cellWidth: 65 },
                5: { cellWidth: 45 },
                6: { cellWidth: 35 },
            } : {};
            // Create a new jsPDF instance
            const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 25 : 30;
            const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 20 : 10;
            pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

            const eOpsLogoWidth = 20;
            const eOpsLogoHeight = 8;
            const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 43 : 17;
            pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);

            const margin = 15;
            const xPosition = pageWidth - margin;

            pdf.setFontSize(10);
            pdf.text(convertDatewithTime(new Date()), xPosition, 12, { align: 'right' });
            pdf.text("Name: " + name, xPosition, 17, { align: 'right' });
            pdf.text("Designation: " + roleName, xPosition, 22, { align: 'right' });


            pdf.setFontSize(12);
            pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
            pdf.text(`Daily Report - ${statsValue == '1' ? "Pending Complaints" : statsValue == '2' ? "Allocated Complaints" : statsValue == '3' ? "Onhold Complaints" : statsValue == '4' ? "Escalated Complaints" : statsValue == '5' ? "Resolved Complaints" : statsValue == '6' ? "Total(All) Complaints" : statsValue == '7' ? "Working Complaints" : ''}`, pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(`${statsValue == '1' ? "Pending Complaints" : statsValue == '2' ? "Allocated Complaints" : statsValue == '3' ? "Onhold Complaints" : statsValue == '4' ? "Escalated Complaints" : statsValue == '5' ? "Resolved Complaints" : statsValue == '6' ? "Total(All) Complaints" : statsValue == '7' ? "Working Complaints" : 'Daily Report'} for ${subdivisionName(hierarchy == 52 ? parseInt(code) : 15171, subDivisions)}`, pageWidth / 2, 25, { align: 'center' });

            pdf.autoTable({
                startY: 28,
                head: [statsValue == '1' ? headers : statsValue == '2' ? headers1 : statsValue == '3' ? headers2 : statsValue == '4' ? headers3 : statsValue == '5' ? headers4 : statsValue == '6' ? headers5 : statsValue == '7' ? headers5 : ''],
                body: statsValue == '1' ? body : statsValue == '2' ? body1 : statsValue == '3' ? body2 : statsValue == '4' ? body3 : statsValue == '5' ? body4 : statsValue == '6' ? body5 : statsValue == '7' ? body6 : '',
                styles: { cellPadding: 1, fontSize: 8 },
                margin: { top: 2 },
                theme: 'striped',
                columnStyles: columnStyles,
                didDrawPage: function (data) {
                    pdf.setFontSize(10);
                },
            });

            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const pageNumberText = `Page ${i} of ${totalPages}`;
                pdf.setFontSize(10);
                pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
            }

            if (print) {
                pdf.save(`${subdivisionName(hierarchy == 52 ? parseInt(code) : 15171, subDivisions) + " " + `Subdivision - MEPCO`}-$Daily Report - ${statsValue == '1' ? "Pending Complaints" : statsValue == '2' ? "Allocated Complaints" : statsValue == '3' ? "Onhold Complaints" : statsValue == '4' ? "Escalated Complaints" : statsValue == '5' ? "Resolved Complaints" : statsValue == '6' && "Total Complaints"}-${dateToPrint}-Complaint-Log.pdf`);
            } else {
                resolve(pdf);
            }

        });
    };
    const exportToExcel = () => {
        if (tableRef.current) {
            let dateToPrint = convertDate(new Date());

            const headerText = `${subdivisionName(hierarchy == 52 ? parseInt(code) : 15171, subDivisions)} Subdivision - MEPCO  (${dateToPrint})`;

            const table = tableRef.current;
            const rows = Array.from(table.querySelectorAll("tr")).map((row) =>
                Array.from(row.querySelectorAll("th, td")).map((cell) => cell.innerText)
            );

            const dataWithHeader = [[headerText], ...rows];

            const ws = XLSX.utils.aoa_to_sheet(dataWithHeader);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

            const filename = `${subdivisionName(hierarchy == 52 ? parseInt(code) : 15171, subDivisions)} Subdivision - MEPCO - ${statsValue == '1' ? "Pending Complaints" : statsValue == '2' ? "Allocated Complaints" : statsValue == '3' ? "Onhold Complaints" : statsValue == '4' ? "Escalated Complaints" : statsValue == '5' ? "Resolved Complaints" : statsValue == '6' && "Total Complaints"} - ${dateToPrint} - Complaint-Log.xlsx`;

            saveAs(new Blob([wbout]), filename);
        }
    };

    const printPDF = async () => {
        let pdf = await DownloadPdf(false);
        const pdfUrl = pdf.output('bloburl');

        // Create an iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);

        // Create a cancel button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.position = 'fixed';
        cancelButton.style.top = '20px';
        cancelButton.style.right = '20px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#ff4d4d';
        cancelButton.style.color = 'white';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '5px';
        cancelButton.style.cursor = 'pointer';
        document.body.appendChild(cancelButton);

        // Print the PDF when the iframe loads
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };

        // Remove iframe and cancel button when cancel button is clicked
        cancelButton.addEventListener('click', () => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
            if (cancelButton.parentNode) {
                document.body.removeChild(cancelButton);
            }
        });
    };
    const handleMarkerClick = (item) => {
        if (!selectedMarker2) {
            setSelectedMarker2(item);
        }
    };

    useEffect(() => {
        const getData = async () => {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            const raw = "";

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "lineComplaints/GetAllComplaintCatagoriesWithNature", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setRemarks(result.data)
                })
                .catch((error) => console.error(error));
        }
        getData()
    }, [token])

    const updateSelectedMarker1 = () => {
        setSelectedMarker2()
    }


    const StatusType = (event) => {
        setStatus(event.target.value);
    };

    const RemarkType = (event) => {
        setRemarkStatus(event.target.value);
    };


    const handleComplaintResolution = async () => {
        // Capture values before any state changes
        const currentStatus = selectedMarker?.Status;
        const currentEOpsTrackingId = selectedMarker?.EOpsTrackingId;

        if (status != '' && remarkStatus != '') {
            if (!currentEOpsTrackingId) return;

            if (remarkStatus == "Other") {
                if (otherComments == '') {
                    alert('Enter remarks!')
                } else {
                    // Optimistic update - update stats immediately before API call
                    updateStatsOptimistically(currentStatus, status);
                    updateParentDataOptimistically(currentStatus, status);

                    // Optimistic update - update complaints list immediately
                    let index = complaints.findIndex(item => item.EOpsTrackingId === currentEOpsTrackingId);
                    if (index !== -1) {
                        const updatedComplaints = [...complaints];
                        updatedComplaints[index] = {
                            ...updatedComplaints[index],
                            Status: status,
                        };
                        setComplaints(updatedComplaints);
                    }

                    setViewBackdrop(true);
                    setShowComplaintForm(false);
                    setSelectedMarker("");

                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);
                    myHeaders.append("Content-Type", "application/json");

                    const raw = JSON.stringify({
                        "TicketNo": "",
                        "EOpsTrackingId": currentEOpsTrackingId,
                        "Status": status,
                        "LinemanRemarks": otherComments,
                        "LinemanAudioRemarks": "",
                        "LinemanImageRemarks": "",
                        "ModifiedBy": userId,
                        "StartTime": "",
                        "EndTime": ""
                    });

                    const requestOptions = {
                        method: "PUT",
                        headers: myHeaders,
                        body: raw,
                        redirect: "follow"
                    };
                    await fetch(cfpBaseUrl + "lineComplaints/updateStatusWMS", requestOptions)
                        .then((response) => response.json())
                        .then((result) => {
                            setViewBackdrop(false)
                            if (result.Message == 'Complaint Status updated successfully.') {
                                setApmsSuccessMessage(status === 'Resolved' ? 'Complaint resolved successfully' : 'Complaint marked on-hold successfully');
                                setShowApmsSuccessDialog(true);
                                dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: hierarchy == 52 ? code : '15171', dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            setViewBackdrop(false)
                        });
                }
            } else {
                // Optimistic update - update stats immediately before API call
                updateStatsOptimistically(currentStatus, status);
                updateParentDataOptimistically(currentStatus, status);

                // Optimistic update - update complaints list immediately
                let index = complaints.findIndex(item => item.EOpsTrackingId === currentEOpsTrackingId);
                if (index !== -1) {
                    const updatedComplaints = [...complaints];
                    updatedComplaints[index] = {
                        ...updatedComplaints[index],
                        Status: status,
                    };
                    setComplaints(updatedComplaints);
                }

                setViewBackdrop(true);
                setShowComplaintForm(false);
                setSelectedMarker("");

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    "TicketNo": "",
                    "EOpsTrackingId": currentEOpsTrackingId,
                    "Status": status,
                    "LinemanRemarks": remarkStatus,
                    "LinemanAudioRemarks": "",
                    "LinemanImageRemarks": "",
                    "ModifiedBy": userId,
                    "StartTime": "",
                    "EndTime": ""
                });

                const requestOptions = {
                    method: "PUT",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow"
                };

                await fetch(cfpBaseUrl + "lineComplaints/updateStatusWMS", requestOptions)
                    .then((response) => response.json())
                    .then((result) => {
                        setViewBackdrop(false)
                        if (result.message == 'Status updated successfully.') {
                            setApmsSuccessMessage(status === 'Resolved' ? 'Complaint resolved successfully' : 'Complaint marked on-hold successfully');
                            setShowApmsSuccessDialog(true);
                            dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: hierarchy == 52 ? code : '15171', dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))
                        }
                    })
                    .catch((error) => console.error(error));
            }
        }
        else {
            if (status == '') {
                alert('Select Status!')
            } else if (remarkStatus == '') {
                alert('Select / Enter remarks!')
            }
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            if (hierarchy == 1) {
                let codeToGeoJSON = code;
                const codeto = codeToGeoJSON.slice(0, 2);
                await AllSubDivisionsForAdmin(token, disco, disco)
                await Promise.all([
                    dispatch(fetchGeoJson({ subDivisionCode: disco, roleTypeId })),
                    dispatch(fetchDivisionGeoJson({ subDivisionCode: hierarchy == 1 ? disco : code.slice(0, 2), roleTypeId }))
                ]);


                // Now you can read the updated localStorage
                const updatedSubDivList = JSON.parse(localStorage.getItem("subDivisions"));
            }

            // For hierarchy 2, 3, 4 - fetch division GeoJson for map
            if (hierarchy == 2 || hierarchy == 3 || hierarchy == 4) {
                const geoJsonCode = hierarchy == 2 ? code.slice(0, 2) : hierarchy == 3 ? (authCircleCode || code.slice(0, 3)) : code.slice(0, 5);
                await dispatch(fetchDivisionGeoJson({ subDivisionCode: geoJsonCode, roleTypeId }));
            }

        }
        fetchData()
    }, [disco, hierarchy])

    const [openParentIndex, setOpenParentIndex] = useState(null);
    const [openChildIndexes, setOpenChildIndexes] = useState({});
    const [openSubChildIndexes, setOpenSubChildIndexes] = useState({});

    let subDivList = JSON.parse(window.localStorage.getItem("subDivisions"));


    const items = [];

    if (!Array.isArray(subDivList)) {
        console.error("subDivList is not an array:", subDivList);
    } else {
        const matchedItems = subDivList.filter((item) => {
            return item.subDivisionCode?.toString().startsWith(Number(code));
        });
        items.push(...matchedItems);
    }
    useEffect(() => {

    },)
    const buildData1 = (data) => {
        const circles = [...new Set(data.map(item => item.circleCode))]
            .map(circleCode => ({
                Code: circleCode?.toString() || null,
                name: data.find(item => item.circleCode === circleCode)?.circleName || null,
                pending: '0',
                allocated: '0',
                resolved: '0',
                total: '0',
                onhold: '0',
                working: '0'
            }))
            .filter(circle => circle.Code); // Remove null circles

        const divisions = [...new Set(data.map(item => item.divisionCode))]
            .map(divisionCode => {
                const divisionData = data.find(item => item.divisionCode === divisionCode);
                return {
                    divisionCode: divisionCode?.toString() || null,
                    divisionName: divisionData?.divisionName || null,
                    circleCode: divisionData?.circleCode?.toString() || null
                };
            });

        const subDiv = data.map(item => ({
            subDivisionCode: item.subDivisionCode?.toString() || null,
            subDivisionName: item.subDivisionName || null,
            divisionCode: item.divisionCode?.toString() || null
        })).filter(sub => sub.subDivisionCode);

        let hierarchy = circles.map(circle => {
            const children = divisions
                .filter(division => division.circleCode === circle.Code)
                .map(division => {
                    const subchildren = subDiv
                        .filter(subDivision => subDivision.divisionCode === division.divisionCode)
                        .map(subDivision => ({
                            name: subDivision.subDivisionName,
                            Code: subDivision.subDivisionCode,
                            pending: '0',
                            allocated: '0',
                            resolved: '0',
                            total: '0',
                            onhold: '0',
                            working: '0'
                        }));

                    return {
                        name: division.divisionName,
                        Code: division.divisionCode,
                        pending: '0',
                        allocated: '0',
                        resolved: '0',
                        onhold: '0',
                        working: '0',
                        total: '0',
                        subchildren
                    };
                });

            return {
                ...circle,
                children
            };
        });

        if (hierarchy.length === 0) {
            hierarchy = divisions.map(division => {
                const subchildren = subDiv
                    .filter(subDivision => subDivision.divisionCode === division.divisionCode)
                    .map(subDivision => ({
                        name: subDivision.subDivisionName,
                        Code: subDivision.subDivisionCode,
                        pending: '0',
                        allocated: '0',
                        resolved: '0',
                        total: '0',
                        onhold: '0',
                        working: '0'
                    }));

                return {
                    name: division.divisionName,
                    Code: division.divisionCode,
                    pending: '0',
                    allocated: '0',
                    resolved: '0',
                    total: '0',
                    onhold: '0',
                    working: '0',
                    children: subchildren
                };
            });
        }

        return hierarchy;
    };


    const data123 = subDivList && buildData1((hierarchy == '2' || hierarchy == '1' || hierarchy == '3' || hierarchy == '4') ? subDivList : items);
    const [parentData, setParentData] = useState([])

    // Fetch weather for all regions in parentData
    useEffect(() => {
        if (parentData && parentData.length > 0) {
            let delayIndex = 0;
            parentData.forEach((parent) => {
                // Fetch weather for parent
                if (!weatherData[parent.Code]) {
                    const city = getCityFromRegion(parent.name);
                    setTimeout(() => {
                        fetchWeather(city, parent.Code);
                    }, delayIndex * 1500);
                    delayIndex++;
                }

                // Fetch weather for children (divisions)
                if (parent.children && parent.children.length > 0) {
                    parent.children.forEach((child) => {
                        if (!weatherData[child.Code]) {
                            const childCity = getCityFromRegion(child.name);
                            setTimeout(() => {
                                fetchWeather(childCity, child.Code);
                            }, delayIndex * 1500);
                            delayIndex++;
                        }
                    });
                }
            });
        }
    }, [parentData]);

    const [code1, setCode1] = useState("15")
    const [otherComments, setOtherComments] = useState('')

    const mapApiDataToHierarchy = (hierarchy, apiData) => {
        let newHierarchy = [];

        hierarchy.forEach((item) => {
            const matchingData = apiData.filter((d) => d.OfficeCode.toString() === item.Code);

            matchingData.forEach((d) => {
                const statusKey = d.Status.toLowerCase();
                if (item[statusKey] !== undefined) {
                    item[statusKey] = d.TotalCount.toString();
                }
            });

            let childrenTotal = 0;
            let subchildrenTotal = 0;

            if (item.children && item.children.length > 0) {
                item.children = mapApiDataToHierarchy(item.children, apiData);
                childrenTotal = item.children.reduce((sum, child) => sum + (parseInt(child.total) || 0), 0);
            }

            if (item.subchildren && item.subchildren.length > 0) {
                item.subchildren = mapApiDataToHierarchy(item.subchildren, apiData);
                subchildrenTotal = item.subchildren.reduce((sum, subchild) => sum + (parseInt(subchild.total) || 0), 0);
            }

            const currentTotal =
                (parseInt(item.allocated) || 0) +
                (parseInt(item.pending) || 0) +
                (parseInt(item.resolved) || 0) +
                (parseInt(item.working) || 0) +
                (parseInt(item.onhold) || 0);

            item.total = (currentTotal + childrenTotal + subchildrenTotal).toString();

            if (item.total !== "0" || item.children?.length > 0 || item.subchildren?.length > 0) {
                newHierarchy.push(item);
            } else if (item.children && item.children.length > 0) {
                item.children.forEach((child) => {
                    child.children = child.subchildren || [];
                    delete child.subchildren;
                    newHierarchy.push(child);
                });
            }
        });

        return newHierarchy;
    };


    useEffect(() => {
        getData();
        getFieldStaffCoordinates()
    }, [disco]);

    // fieldStaff state - data comes from API, stored in component state
    const [fieldStaff, setFieldStaff] = useState([]);


    const getFieldStaffCoordinates = async () => {
        const currentDisco = hierarchy == 1 ? disco : hierarchy == 2 ? code.slice(0, 2) : hierarchy == 3 ? (authCircleCode || code.slice(0, 3)) : hierarchy == 4 ? code.slice(0, 5) : hierarchy == 52 ? code : '15';
        const requestDisco = currentDisco; // Capture disco at request time

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", token);

        const raw = JSON.stringify({
            "officeCode": currentDisco,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        await fetch(cfpBaseUrl + "reports/GetLineManCoordinates", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                // Only set data if disco hasn't changed since request was made
                if (hierarchy == 1 && discoRef.current !== requestDisco) {
                    console.log('Ignoring stale fieldStaff response');
                    return;
                }
                setFieldStaff(result.data);
                setCompanyFieldStaff(result.data);
            })
            .catch((error) => console.error(error));
    }

    // Fetch field staff/lineman for specific subdivision (used in hierarchy 4)
    const getFieldStaffBySubdivision = async (subDivCode) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", token);

        const raw = JSON.stringify({
            "officeCode": subDivCode,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        await fetch(cfpBaseUrl + "reports/GetLineManCoordinates", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setFieldStaff(result.data);
            })
            .catch((error) => console.error(error));
    }
    const getData = async () => {
        // try {
        //     const myHeaders = new Headers();
        //     myHeaders.append("Authorization", token);
        //     myHeaders.append("Content-Type", "application/json");

        //     const raw = JSON.stringify({
        //         "officeCode": hierarchy == 1 ? disco : hierarchy == 2 ? code.slice(0, 2) : hierarchy == 3 ? code.slice(0, 3) : hierarchy == 4 ? code.slice(0, 4) : hierarchy == 52 ? code : '15',
        //         "dateFrom": dateFrom,
        //         "dateTo": dateTo
        //     });

        //     const requestOptions = {
        //         method: "POST",
        //         headers: myHeaders,
        //         body: raw,
        //         redirect: "follow"
        //     };
        //     await fetch(cfpBaseUrl + "lineComplaints/getComplaintCountStatusWiseHierarchical", requestOptions)
        //         .then((response) => response.json())
        //         .then((result) => {

        //             if (result.status == 200) {
        //                 const updatedData = [...data123];
        //                 mapApiDataToHierarchy(updatedData, result.data);
        //                 setParentData(updatedData);


        //                 const statusSumMap = {
        //                     Pending: 0,
        //                     Allocated: 0,
        //                     Working: 0,
        //                     Onhold: 0,
        //                     Escalated: 0,
        //                     Resolved: 0
        //                 };

        //                 result.data.forEach(item => {
        //                     const statusKey = item.Status?.toLowerCase();
        //                     const matchedKey = Object.keys(statusSumMap).find(
        //                         key => key.toLowerCase() === statusKey
        //                     );
        //                     if (matchedKey) {
        //                         statusSumMap[matchedKey] += item.TotalCount || 0;
        //                     }
        //                 });

        //                 setPendingStats(statusSumMap.Pending);
        //                 setAllocatedStats(statusSumMap.Allocated);
        //                 setOnholdStats(statusSumMap.Onhold);
        //                 setEscalatedStats(statusSumMap.Escalated);
        //                 setWorkingStats(statusSumMap.Working);
        //                 setResolvedStats(statusSumMap.Resolved);


        //                 const total = (statusSumMap?.Pending || 0) +
        //                     (statusSumMap.Allocated || 0) +
        //                     (statusSumMap.Onhold || 0) +
        //                     (statusSumMap.Escalated || 0) +
        //                     (statusSumMap.Working || 0) +
        //                     (statusSumMap.Resolved || 0)


        //                 console.log(total, 'total')
        //                 setAllComplaintsState(total);
        //                 setTotalComplaints(total);
        //             } else {
        //                 setComplaintData(true)
        //             }


        //         })
        //         .catch((error) => console.error(error));
        // } catch (error) {
        //     console.error("Error fetching data:", error);
        // }
    };

    const toggleParent = (parent, index) => {
        setCircleName(parent.name)
        setCircleCode(parent.Code)
        setDivisionCode("")

        setDivisionName("")
        setOpenParentIndex(openParentIndex === index ? null : index);
    };

    const toggleChild = (parentIndex, childIndex, child) => {
        setDivisionName(child.name)
        setCircleCode("")
        setDivisionCode(child.Code)
        setOpenChildIndexes((prev) => ({
            ...prev,
            [parentIndex]: prev[parentIndex] === childIndex ? null : childIndex,
        }));
    };
    useEffect(() => {
        if (parentData && parentData.length > 0) {
            setIsLoading(false);
        }
    }, [parentData]);

    const toggleSubChild = (parentIndex, childIndex, subChildIndex) => {

        setOpenSubChildIndexes((prev) => ({
            ...prev,
            [parentIndex]: {
                ...prev[parentIndex],
                [childIndex]:
                    prev[parentIndex]?.[childIndex] === subChildIndex ? null : subChildIndex,
            },
        }));
    };

    const colorArray = [
        "#c4dfac",
        "#e3c088",
        "#9eecf3",
        "#fdf89a",
        "#d4e2fb",
        "#caf8ff",
        "#b2b5ea",
        "#aad3f0",
        "#fee4e5",
    ];

    function getColor(index) {
        return colorArray[index % colorArray.length];
    }

    const getWeatherInsights = () => {
        if (!parentData || parentData.length === 0 || Object.keys(weatherData).length === 0) {
            return null;
        }

        const circlesWithWeather = parentData.map(circle => {
            const weather = weatherData[circle.Code];
            const activeComplaints = parseInt(circle.pending || 0) + parseInt(circle.allocated || 0) + parseInt(circle.onhold || 0) + parseInt(circle.working || 0);
            return {
                name: circle.name,
                code: circle.Code,
                temp: weather ? weather.temp : null,
                description: weather ? weather.description : '',
                icon: weather ? weather.icon : '',
                activeComplaints,
                total: parseInt(circle.total || 0),
                pending: parseInt(circle.pending || 0),
            };
        }).filter(c => c.temp !== null);

        if (circlesWithWeather.length === 0) return null;

        // Heatwave circles (>= 40°C)
        const heatwaveCircles = circlesWithWeather.filter(c => c.temp >= 40);

        // Rain/storm circles
        const rainStormCircles = circlesWithWeather.filter(c => {
            const desc = (c.description || '').toLowerCase();
            return desc.includes('rain') || desc.includes('storm') || desc.includes('thunder') || desc.includes('drizzle') || desc.includes('shower');
        });

        // Correlation: hot (>= 38) vs mild (< 38)
        const hotCircles = circlesWithWeather.filter(c => c.temp >= 38);
        const mildCircles = circlesWithWeather.filter(c => c.temp < 38);
        const avgHot = hotCircles.length > 0 ? Math.round(hotCircles.reduce((s, c) => s + c.activeComplaints, 0) / hotCircles.length) : 0;
        const avgMild = mildCircles.length > 0 ? Math.round(mildCircles.reduce((s, c) => s + c.activeComplaints, 0) / mildCircles.length) : 0;
        const spikePercent = avgMild > 0 ? Math.round(((avgHot - avgMild) / avgMild) * 100) : 0;

        // Worst circle by active complaints (highest load)
        const worstCircle = circlesWithWeather.reduce((max, c) => c.activeComplaints > max.activeComplaints ? c : max, circlesWithWeather[0]);

        // Best circle by active complaints (lowest load)
        const bestCircle = circlesWithWeather.reduce((min, c) => c.activeComplaints < min.activeComplaints ? c : min, circlesWithWeather[0]);

        // Sort by active complaints descending (highest first)
        const sortedByTemp = [...circlesWithWeather].sort((a, b) => b.activeComplaints - a.activeComplaints);

        return {
            heatwaveCircles,
            rainStormCircles,
            avgHot,
            avgMild,
            spikePercent,
            hotCount: hotCircles.length,
            mildCount: mildCircles.length,
            worstCircle,
            bestCircle,
            sortedByTemp,
        };
    };

    // Daily Performance Snapshot - Today's Summary
    const getDailySnapshot = () => {
        const received = totalComplaints ? parseInt(totalComplaints) : 0;
        const resolved = resolvedStats ? parseInt(resolvedStats) : 0;

        // Calculate average resolution time from resolved complaints today
        let avgTimeHrs = 0;
        if (complaints && complaints.length > 0) {
            const resolvedComps = complaints.filter(c => c.Status === 'Resolved' && c.ResolvedAt);
            if (resolvedComps.length > 0) {
                const totalMinutes = resolvedComps.reduce((sum, c) => {
                    const registered = new Date(c.RegisteredAt);
                    const resolvedDate = new Date(c.ResolvedAt);
                    const diff = (resolvedDate - registered) / (1000 * 60); // minutes
                    return sum + (diff > 0 ? diff : 0);
                }, 0);
                avgTimeHrs = (totalMinutes / resolvedComps.length / 60).toFixed(1);
            }
        }

        // Calculate circle-wise stats with average resolution time
        let circleRankings = [];
        if (parentData && parentData.length > 0 && complaints && complaints.length > 0) {
            circleRankings = parentData.map(circle => {
                // Get complaints for this circle based on SubDivisionCode prefix
                const circleComplaints = complaints.filter(c => {
                    const subDivCode = c.SubDivisionCode?.toString() || '';
                    return subDivCode.startsWith(circle.Code);
                });

                const circleResolved = circleComplaints.filter(c => c.Status === 'Resolved' && c.ResolvedAt);
                const totalReceived = circleComplaints.length;
                const totalResolved = circleResolved.length;

                // Calculate avg resolution time for this circle
                let circleAvgTime = 0;
                if (circleResolved.length > 0) {
                    const totalMins = circleResolved.reduce((sum, c) => {
                        const reg = new Date(c.RegisteredAt);
                        const res = new Date(c.ResolvedAt);
                        const diff = (res - reg) / (1000 * 60);
                        return sum + (diff > 0 ? diff : 0);
                    }, 0);
                    circleAvgTime = parseFloat((totalMins / circleResolved.length / 60).toFixed(1));
                }

                const activeComplaints = parseInt(circle.pending || 0) + parseInt(circle.allocated || 0) + parseInt(circle.onhold || 0) + parseInt(circle.working || 0);

                return {
                    name: circle.name,
                    code: circle.Code,
                    received: totalReceived || parseInt(circle.total || 0),
                    resolved: totalResolved || parseInt(circle.resolved || 0),
                    avgTimeHrs: circleAvgTime,
                    active: activeComplaints,
                    pending: parseInt(circle.pending || 0)
                };
            });

            // Sort by active complaints descending (most pending first)
            circleRankings.sort((a, b) => b.active - a.active);
        }

        // Get worst circle (slowest avg time)
        const worstCircle = circleRankings.length > 0 ? circleRankings[0] : null;

        return {
            received,
            resolved,
            avgTimeHrs,
            worstCircle: worstCircle?.name || '-',
            circleRankings
        };
    };

    // Lineman Productivity Insights
    const getLinemanInsights = () => {
        if (!fieldStaff || fieldStaff.length === 0) {
            return null;
        }

        // Calculate active vs inactive linemen
        const activeLinemen = fieldStaff.filter(l => l.isActive === 1 || l.isActive === true || l.status === 'Active');
        const inactiveLinemen = fieldStaff.filter(l => l.isActive === 0 || l.isActive === false || l.status === 'Inactive' || l.status === 'Offline');

        // Group complaints by allocated lineman
        const linemanComplaintMap = {};
        if (complaints && complaints.length > 0) {
            complaints.forEach(c => {
                if (c.AllocatedTo) {
                    if (!linemanComplaintMap[c.AllocatedTo]) {
                        linemanComplaintMap[c.AllocatedTo] = {
                            allocated: 0,
                            resolved: 0,
                            working: 0,
                            pending: 0,
                            onhold: 0
                        };
                    }
                    if (c.Status === 'Resolved') {
                        linemanComplaintMap[c.AllocatedTo].resolved++;
                    } else if (c.Status === 'Working') {
                        linemanComplaintMap[c.AllocatedTo].working++;
                    } else if (c.Status === 'Allocated') {
                        linemanComplaintMap[c.AllocatedTo].allocated++;
                    } else if (c.Status === 'onhold' || c.Status === 'Onhold') {
                        linemanComplaintMap[c.AllocatedTo].onhold++;
                    }
                }
            });
        }

        // Map userIds to complaints and calculate efficiency
        const linemanWithStats = userIds.map(user => {
            const stats = linemanComplaintMap[user.userId] || { allocated: 0, resolved: 0, working: 0, pending: 0, onhold: 0 };
            const totalAssigned = stats.allocated + stats.resolved + stats.working + stats.onhold;
            const efficiency = totalAssigned > 0 ? Math.round((stats.resolved / totalAssigned) * 100) : 0;
            return {
                id: user.userId,
                name: user.employeeName || 'Unknown',
                code: user.employeeCode || '-',
                ...stats,
                totalAssigned,
                efficiency,
                isIdle: totalAssigned === 0
            };
        });

        // Sort by total assigned (top performers)
        const topPerformers = [...linemanWithStats].filter(l => l.totalAssigned > 0).sort((a, b) => b.resolved - a.resolved).slice(0, 5);

        // Idle linemen (no tasks)
        const idleLinemen = linemanWithStats.filter(l => l.isIdle);

        // Stats summary
        const totalLinemen = fieldStaff.length;
        const totalActiveComplaints = Object.values(linemanComplaintMap).reduce((sum, l) => sum + l.allocated + l.working + l.onhold, 0);
        const totalResolved = Object.values(linemanComplaintMap).reduce((sum, l) => sum + l.resolved, 0);

        return {
            totalLinemen,
            activeCount: activeLinemen.length,
            inactiveCount: inactiveLinemen.length,
            topPerformers,
            idleLinemen,
            totalActiveComplaints,
            totalResolved,
            linemanWithStats
        };
    };

    const complaintSearchFormik = useFormik({
        initialValues: {
            iv_search_tracking_id: '',
        },
        validationSchema: Yup.object({
            iv_search_tracking_id: Yup.string()
                .required('Enter 18-digit Complaint ID.')
                .min(13, 'Complaint ID should be at least 13 digits.')
                .max(18, 'Complaint ID should be at most 18 digits.'),
        }),
        onSubmit: async (values) => {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                TicketNoOrEOpsTrackingId: values.iv_search_tracking_id
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "lineComplaints/getComplaintsWithHistByTicketNo", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setViewBackdrop(false);
                    setSerachedTrackingId(values.iv_search_tracking_id);

                    if (result.status === "200") {
                        const complaints = result.data;
                        if (complaints.length > 1) {
                            setMultipleComplaints(complaints);
                            setOpenComplaintPopup(true);
                            values.iv_search_tracking_id = ''

                        } else {
                            const complaintData = complaints[0];
                            setSelectedMarker(complaintData);
                            setPowerComplaintsToDataGrid('');
                            setOnPressComplaint(complaintData);
                            setShowComplaintForm(true);
                            values.iv_search_tracking_id = ''
                        }

                    } else {
                        setComplaintNotFoundMessage(result.message);
                        setOpenComplaintError(true);
                    }
                })
                .catch((error) => console.error(error));
        },
    });

    const handleSelectComplaint = (complaint) => {
        setSelectedMarker(complaint);
        setPowerComplaintsToDataGrid('');
        setOnPressComplaint(complaint);
        setShowComplaintForm(true);
    };

    const onPressCompany = async () => {
        // Collapse the hierarchy and reload company-level map
        dispatch(updateOC({ officeCode: code.slice(0, 2) }));

        // Reset home button state to true (company level - no filtering)
        dispatch(updateHomeButton(true));

        setCircleCodeData('');
        setDivisionCodeData('');
        setCircleName('');
        setDivisionName('');
        setSubDivision('');
        setConnections(null); // Clear APMS connections
        setOpenParentIndex(null);
        setOpenChildIndexes({});
        setOpenSubChildIndexes({});

        // Reset lineman selection and restore company-level cached data (no API calls)
        setSelectedLineman('');
        setUserIds(companyUserIds);
        setFieldStaff(companyFieldStaff);

        // Update stats to show company level totals
        if (parentData && parentData.length > 0) {
            let totalPending = 0, totalAllocated = 0, totalOnhold = 0, totalEscalated = 0, totalWorking = 0, totalResolved = 0;
            parentData.forEach(circle => {
                totalPending += parseInt(circle.pending || 0);
                totalAllocated += parseInt(circle.allocated || 0);
                totalOnhold += parseInt(circle.onhold || 0);
                totalEscalated += parseInt(circle.escalated || 0);
                totalWorking += parseInt(circle.working || 0);
                totalResolved += parseInt(circle.resolved || 0);
            });
            setPendingStats(totalPending);
            setAllocatedStats(totalAllocated);
            setOnholdStats(totalOnhold);
            setEscalatedStats(totalEscalated);
            setWorkingStats(totalWorking);
            setResolvedStats(totalResolved);
            setTotalComplaints(totalPending + totalAllocated + totalOnhold + totalEscalated + totalWorking + totalResolved);
        }

        // Fetch company-level geoJSON for proper map rendering
        await dispatch(fetchGeoJson({ subDivisionCode: disco, roleTypeId }));

        setIsLoading(false);
    };

    const [childData, setChildData] = useState({});
    const [subChildData, setSubChildData] = useState({});
    const [loading, setLoading] = useState({
        parents: true,
        children: {},
        subchildren: {}
    });

    const updateStats = (obj) => {
        console.log("=== updateStats CALLED ===");
        console.log("Stats object:", obj);
        console.log("Pending:", obj.pending, "Allocated:", obj.allocated, "Working:", obj.working);
        setPendingStats(parseInt(obj.pending || 0));
        setAllocatedStats(parseInt(obj.allocated || 0));
        setOnholdStats(parseInt(obj.onhold || 0));
        setEscalatedStats(parseInt(obj.escalated || 0));
        setWorkingStats(parseInt(obj.working || 0));
        setResolvedStats(parseInt(obj.resolved || 0));

        const total =
            parseInt(obj.pending || 0) +
            parseInt(obj.allocated || 0) +
            parseInt(obj.onhold || 0) +
            parseInt(obj.escalated || 0) +
            parseInt(obj.working || 0) +
            parseInt(obj.resolved || 0);

        console.log("Total calculated:", total);
        setTotalComplaints(total);
        setStatsLoading(false);
    };

    // Optimistic update for stats when complaint status changes
    const updateStatsOptimistically = (fromStatus, toStatus) => {
        if (!fromStatus || !toStatus) return;
        console.log('Optimistic Update:', fromStatus, '->', toStatus);

        // Decrement the source status
        if (fromStatus === 'Pending') {
            setPendingStats(prev => Math.max(0, (parseInt(prev) || 0) - 1));
        } else if (fromStatus === 'Allocated') {
            setAllocatedStats(prev => Math.max(0, (parseInt(prev) || 0) - 1));
        } else if (fromStatus === 'Onhold' || fromStatus === 'onhold' || fromStatus === 'OnHold') {
            setOnholdStats(prev => Math.max(0, (parseInt(prev) || 0) - 1));
        } else if (fromStatus === 'Working') {
            setWorkingStats(prev => Math.max(0, (parseInt(prev) || 0) - 1));
        }

        // Increment the target status
        if (toStatus === 'Allocated') {
            setAllocatedStats(prev => (parseInt(prev) || 0) + 1);
        } else if (toStatus === 'Resolved') {
            setResolvedStats(prev => (parseInt(prev) || 0) + 1);
            // Resolved complaints are excluded from total, so decrement total
            setTotalComplaints(prev => Math.max(0, (parseInt(prev) || 0) - 1));
        } else if (toStatus === 'Onhold' || toStatus === 'onhold' || toStatus === 'OnHold') {
            setOnholdStats(prev => (parseInt(prev) || 0) + 1);
        } else if (toStatus === 'Working') {
            setWorkingStats(prev => (parseInt(prev) || 0) + 1);
        }
    };

    // Optimistic update for parentData hierarchy when complaint status changes
    const updateParentDataOptimistically = (fromStatus, toStatus) => {
        if (!fromStatus || !toStatus) return;

        const normalizeStatus = (status) => {
            if (status === 'Onhold' || status === 'onhold' || status === 'OnHold') return 'onhold';
            return status.toLowerCase();
        };

        const fromKey = normalizeStatus(fromStatus);
        const toKey = normalizeStatus(toStatus);

        setParentData((prevData) => {
            return prevData.map((parent) => {
                // Check if this parent (circle) matches current selection
                const isSelectedCircle = circleCodeData === parent.Code;

                // Update parent counts if this is the selected circle
                let updatedParent = { ...parent };
                if (isSelectedCircle || !circleCodeData) {
                    // Decrement from source
                    if (fromKey === 'pending') {
                        updatedParent.pending = Math.max(0, (parseInt(updatedParent.pending) || 0) - 1).toString();
                    } else if (fromKey === 'allocated') {
                        updatedParent.allocated = Math.max(0, (parseInt(updatedParent.allocated) || 0) - 1).toString();
                    } else if (fromKey === 'onhold') {
                        updatedParent.onhold = Math.max(0, (parseInt(updatedParent.onhold) || 0) - 1).toString();
                    } else if (fromKey === 'working') {
                        updatedParent.working = Math.max(0, (parseInt(updatedParent.working) || 0) - 1).toString();
                    }

                    // Increment to target
                    if (toKey === 'allocated') {
                        updatedParent.allocated = ((parseInt(updatedParent.allocated) || 0) + 1).toString();
                    } else if (toKey === 'resolved') {
                        updatedParent.resolved = ((parseInt(updatedParent.resolved) || 0) + 1).toString();
                        updatedParent.total = Math.max(0, (parseInt(updatedParent.total) || 0) - 1).toString();
                    } else if (toKey === 'onhold') {
                        updatedParent.onhold = ((parseInt(updatedParent.onhold) || 0) + 1).toString();
                    } else if (toKey === 'working') {
                        updatedParent.working = ((parseInt(updatedParent.working) || 0) + 1).toString();
                    }
                }

                // Update children (divisions)
                if (updatedParent.children && updatedParent.children.length > 0) {
                    updatedParent.children = updatedParent.children.map((child) => {
                        const isSelectedDivision = divisionCodeData === child.Code;
                        let updatedChild = { ...child };

                        if (isSelectedDivision || (!divisionCodeData && isSelectedCircle)) {
                            // Decrement from source
                            if (fromKey === 'pending') {
                                updatedChild.pending = Math.max(0, (parseInt(updatedChild.pending) || 0) - 1).toString();
                            } else if (fromKey === 'allocated') {
                                updatedChild.allocated = Math.max(0, (parseInt(updatedChild.allocated) || 0) - 1).toString();
                            } else if (fromKey === 'onhold') {
                                updatedChild.onhold = Math.max(0, (parseInt(updatedChild.onhold) || 0) - 1).toString();
                            } else if (fromKey === 'working') {
                                updatedChild.working = Math.max(0, (parseInt(updatedChild.working) || 0) - 1).toString();
                            }

                            // Increment to target
                            if (toKey === 'allocated') {
                                updatedChild.allocated = ((parseInt(updatedChild.allocated) || 0) + 1).toString();
                            } else if (toKey === 'resolved') {
                                updatedChild.resolved = ((parseInt(updatedChild.resolved) || 0) + 1).toString();
                                updatedChild.total = Math.max(0, (parseInt(updatedChild.total) || 0) - 1).toString();
                            } else if (toKey === 'onhold') {
                                updatedChild.onhold = ((parseInt(updatedChild.onhold) || 0) + 1).toString();
                            } else if (toKey === 'working') {
                                updatedChild.working = ((parseInt(updatedChild.working) || 0) + 1).toString();
                            }
                        }

                        // Update subchildren (subdivisions)
                        if (updatedChild.children && updatedChild.children.length > 0) {
                            updatedChild.children = updatedChild.children.map((subchild) => {
                                const isSelectedSubdivision = subDivision === subchild.Code;
                                let updatedSubchild = { ...subchild };

                                if (isSelectedSubdivision) {
                                    // Decrement from source
                                    if (fromKey === 'pending') {
                                        updatedSubchild.pending = Math.max(0, (parseInt(updatedSubchild.pending) || 0) - 1).toString();
                                    } else if (fromKey === 'allocated') {
                                        updatedSubchild.allocated = Math.max(0, (parseInt(updatedSubchild.allocated) || 0) - 1).toString();
                                    } else if (fromKey === 'onhold') {
                                        updatedSubchild.onhold = Math.max(0, (parseInt(updatedSubchild.onhold) || 0) - 1).toString();
                                    } else if (fromKey === 'working') {
                                        updatedSubchild.working = Math.max(0, (parseInt(updatedSubchild.working) || 0) - 1).toString();
                                    }

                                    // Increment to target
                                    if (toKey === 'allocated') {
                                        updatedSubchild.allocated = ((parseInt(updatedSubchild.allocated) || 0) + 1).toString();
                                    } else if (toKey === 'resolved') {
                                        updatedSubchild.resolved = ((parseInt(updatedSubchild.resolved) || 0) + 1).toString();
                                        updatedSubchild.total = Math.max(0, (parseInt(updatedSubchild.total) || 0) - 1).toString();
                                    } else if (toKey === 'onhold') {
                                        updatedSubchild.onhold = ((parseInt(updatedSubchild.onhold) || 0) + 1).toString();
                                    } else if (toKey === 'working') {
                                        updatedSubchild.working = ((parseInt(updatedSubchild.working) || 0) + 1).toString();
                                    }
                                }

                                return updatedSubchild;
                            });
                        }

                        return updatedChild;
                    });
                }

                return updatedParent;
            });
        });
    };

    const fetchCircles = async () => {
        setLoading((prev) => ({ ...prev, parents: true }));
        const requestDisco = disco; // Capture disco at request time

        try {
            // For division level (hierarchy === 4), use division code directly
            const officeCode = hierarchy === 1 ? disco : hierarchy === 4 ? code.slice(0, 4) : code.slice(0, 2);

            const response = await fetch(
                `${cfpBaseUrl}lineComplaints/getComplaintCountStatusWiseHierarchical`,
                {
                    method: "POST",
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        officeCode,
                        dateFrom,
                        dateTo,
                    }),
                }
            );

            const result = await response.json();

            if (result.status == 200) {
                // For division level (hierarchy === 4), show division as parent with subdivisions as children
                if (hierarchy === 4) {
                    const subDivMap = {};

                    result.data.forEach((item) => {
                        const subDivCode = item.OfficeCode.toString();

                        if (!subDivMap[subDivCode]) {
                            subDivMap[subDivCode] = {
                                Code: subDivCode,
                                name: item.OfficeName,
                                pending: "0",
                                allocated: "0",
                                onhold: "0",
                                escalated: "0",
                                working: "0",
                                resolved: "0",
                                total: "0",
                            };
                        }

                        const statusKey = item.Status?.trim().toLowerCase();
                        if (subDivMap[subDivCode][statusKey] !== undefined) {
                            subDivMap[subDivCode][statusKey] = (
                                parseInt(subDivMap[subDivCode][statusKey] || 0) +
                                parseInt(item.TotalCount || 0)
                            ).toString();
                        }
                    });

                    let subDivisions = Object.values(subDivMap).map((sub) => {
                        const total = (
                            parseInt(sub.pending || 0) +
                            parseInt(sub.allocated || 0) +
                            parseInt(sub.onhold || 0) +
                            parseInt(sub.escalated || 0) +
                            parseInt(sub.working || 0) +
                            parseInt(sub.resolved || 0)
                        ).toString();
                        return { ...sub, total };
                    });

                    const totalPendingSum = subDivisions.reduce((sum, sub) => sum + parseInt(sub.pending || 0), 0);
                    const totalAllocatedSum = subDivisions.reduce((sum, sub) => sum + parseInt(sub.allocated || 0), 0);
                    const totalWorkingSum = subDivisions.reduce((sum, sub) => sum + parseInt(sub.working || 0), 0);
                    const totalEscalatedSum = subDivisions.reduce((sum, sub) => sum + parseInt(sub.escalated || 0), 0);
                    const totalResolvedSum = subDivisions.reduce((sum, sub) => sum + parseInt(sub.resolved || 0), 0);
                    const totalOnholdSum = subDivisions.reduce((sum, sub) => sum + parseInt(sub.onhold || 0), 0);
                    const totalAllStats = totalPendingSum + totalAllocatedSum + totalOnholdSum + totalEscalatedSum + totalWorkingSum + totalResolvedSum;

                    setPendingStats(totalPendingSum);
                    setAllocatedStats(totalAllocatedSum);
                    setOnholdStats(totalOnholdSum);
                    setEscalatedStats(totalEscalatedSum);
                    setWorkingStats(totalWorkingSum);
                    setResolvedStats(totalResolvedSum);
                    setTotalComplaints(totalAllStats);
                    setStatsLoading(false);

                    // Create division as parent with subdivisions as children
                    const divisionCode = code.slice(0, 4);

                    // Get division name using the getDivisionName function from services
                    const subDivListData = JSON.parse(window.localStorage.getItem("subDivisions")) || [];
                    const divName = getDivisionName(parseInt(divisionCode), subDivListData) || "Division";

                    const divisionParent = {
                        Code: divisionCode,
                        name: divName,
                        pending: totalPendingSum.toString(),
                        allocated: totalAllocatedSum.toString(),
                        onhold: totalOnholdSum.toString(),
                        escalated: totalEscalatedSum.toString(),
                        working: totalWorkingSum.toString(),
                        resolved: totalResolvedSum.toString(),
                        total: totalAllStats.toString(),
                        children: subDivisions, // Subdivisions as children
                    };

                    setParentData([divisionParent]);
                    setLoading((prev) => ({ ...prev, parents: false }));
                    return;
                }

                const circleMap = {};

                const filteredData = hierarchy === 1
                    ? result.data.filter((item) => item.OfficeType?.toLowerCase() === "circle" || item.OfficeCode?.toString().length === 3)
                    : result.data;

                filteredData.forEach((item) => {
                    const originalCode = item.OfficeCode.toString();
                    const circleCode = hierarchy === 3
                        ? originalCode.slice(0, 3)
                        : originalCode;

                    if (!circleMap[circleCode]) {


                        const originalCode = item.OfficeCode.toString();
                        const code = hierarchy === 3
                            ? originalCode.slice(0, 3)
                            : originalCode;

                        circleMap[circleCode] = {
                            Code: code,
                            name: hierarchy === 3
                                ? `${item.OfficeName}`  // Circle ka naam
                                : item.OfficeName,
                            pending: "0",
                            allocated: "0",
                            onhold: "0",
                            escalated: "0",
                            working: "0",
                            resolved: "0",
                            // closed: "0",
                            // reopen: "0",
                            total: "0",
                            children: [],
                        };
                    }

                    // Map status to the correct key
                    const statusKey = item.Status?.trim().toLowerCase();

                    // Add count to Circle's aggregated stats
                    if (circleMap[circleCode][statusKey] !== undefined) {
                        circleMap[circleCode][statusKey] = (
                            parseInt(circleMap[circleCode][statusKey] || 0) +
                            parseInt(item.TotalCount || 0)
                        ).toString();
                    }
                });

                let circles = Object.values(circleMap).map((circle) => {
                    const total = (
                        parseInt(circle.pending || 0) +
                        parseInt(circle.allocated || 0) +
                        parseInt(circle.onhold || 0) +
                        parseInt(circle.escalated || 0) +
                        parseInt(circle.working || 0) +
                        parseInt(circle.resolved || 0)
                        // parseInt(circle.closed || 0) +
                        // parseInt(circle.reopen || 0)
                    ).toString();

                    return { ...circle, total };
                });

                // Filter to show only user's circle
                if (hierarchy === 3) {
                    const userCircleCode = authCircleCode || code.slice(0, 3);
                    circles = circles.filter(circle => circle.Code === userCircleCode);
                }

                // Calculate total pending sum for all parents
                const totalPendingSum = circles.reduce((sum, circle) => {
                    return sum + parseInt(circle.pending || 0);
                }, 0);

                const totalAllocatedSum = circles.reduce((sum, circle) => {
                    return sum + parseInt(circle.allocated || 0);
                }, 0);

                const totalWorkingSum = circles.reduce((sum, circle) => {
                    return sum + parseInt(circle.working || 0);
                }, 0);

                const totalEscalatedSum = circles.reduce((sum, circle) => {
                    return sum + parseInt(circle.escalated || 0);
                }, 0);

                const totalResolvedSum = circles.reduce((sum, circle) => {
                    return sum + parseInt(circle.resolved || 0);
                }, 0);

                const totalOnholdSum = circles.reduce((sum, circle) => {
                    return sum + parseInt(circle.onhold || 0);
                }, 0);

                const totalAllStats =
                    totalPendingSum +
                    totalAllocatedSum +
                    totalOnholdSum +
                    totalEscalatedSum +
                    totalWorkingSum +
                    totalResolvedSum;

                setPendingStats(totalPendingSum);
                setAllocatedStats(totalAllocatedSum);
                setOnholdStats(totalOnholdSum);
                setEscalatedStats(totalEscalatedSum);
                setWorkingStats(totalWorkingSum);
                setResolvedStats(totalResolvedSum);
                setTotalComplaints(totalAllStats);
                setStatsLoading(false);
                // setPendingStats(totalPendingSum);
                // setAllocatedStats(totalAllocatedSum);
                // setOnholdStats(totalWorkingSum);
                // setEscalatedStats(totalEscalatedSum);
                // setWorkingStats(totalResolvedSum);
                // setResolvedStats(statusSumMap.Resolved);
                // const totalOnholdSum = circles.reduce((sum, circle) => {
                //     return sum + parseInt(circle.onhold || 0);
                // }, 0);



                // Only set data if disco hasn't changed since request was made
                if (hierarchy === 1 && discoRef.current !== requestDisco) {
                    console.log('Ignoring stale circles response');
                    return;
                }
                setParentData(circles);
            }
        } catch (error) {
            console.error("Error fetching circles:", error);
        } finally {
            setStatsLoading(false);
            setLoading((prev) => ({ ...prev, parents: false }));
        }
    };

    const fetchDivisions = async (circleCode) => {
        setLoading((prev) => ({
            ...prev,
            children: { ...prev.children, [circleCode]: true },
        }));

        try {
            const response = await fetch(
                `${cfpBaseUrl}lineComplaints/getComplaintCountStatusWiseHierarchical`,
                {
                    method: "POST",
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        officeCode: circleCode,
                        dateFrom,
                        dateTo,
                    }),
                }
            );

            const result = await response.json();

            if (result.status == 200) {
                const divisionMap = {};

                result.data.forEach((item) => {
                    const code = item.OfficeCode.toString();

                    if (!divisionMap[code]) {
                        divisionMap[code] = {
                            Code: code,
                            name: item.OfficeName,
                            pending: "0",
                            allocated: "0",
                            onhold: "0",
                            escalated: "0",
                            working: "0",
                            resolved: "0",
                            total: "0",
                            subchildren: [],
                        };
                    }

                    const status = item.Status.toLowerCase();
                    divisionMap[code][status] = (
                        parseInt(divisionMap[code][status] || 0) +
                        parseInt(item.TotalCount || 0)
                    ).toString();
                });

                const divisions = Object.values(divisionMap).map((division) => {
                    const total =
                        parseInt(division.pending || 0) +
                        parseInt(division.allocated || 0) +
                        parseInt(division.onhold || 0) +
                        parseInt(division.escalated || 0) +
                        parseInt(division.working || 0) +
                        parseInt(division.resolved || 0);

                    return { ...division, total: total.toString() };
                });

                // ✅ FIX: Preserve circle stats and only attach divisions
                setParentData((prev) =>
                    prev.map((parent) => {
                        if (parent.Code === circleCode) {
                            return {
                                ...parent, // preserve stats
                                children: divisions, // add divisions
                            };
                        }
                        return parent;
                    })
                );
            }
        } catch (error) {
            console.error(`Error fetching divisions for circle ${circleCode}:`, error);
        } finally {
            setLoading((prev) => ({
                ...prev,
                children: { ...prev.children, [circleCode]: false },
            }));
        }
    };

    const fetchSubDivisions = async (circleCode, divisionCode) => {
        setLoading((prev) => ({
            ...prev,
            subchildren: { ...prev.subchildren, [divisionCode]: true },
        }));

        try {
            const response = await fetch(
                `${cfpBaseUrl}lineComplaints/getComplaintCountStatusWiseHierarchical`,
                {
                    method: "POST",
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        officeCode: divisionCode,
                        dateFrom,
                        dateTo,
                    }),
                }
            );

            const result = await response.json();

            if (result.status == 200) {
                const subDivisionMap = {};

                result.data.forEach((item) => {
                    const code = item.OfficeCode.toString();

                    if (!subDivisionMap[code]) {
                        subDivisionMap[code] = {
                            Code: code,
                            name: item.OfficeName,
                            pending: "0",
                            allocated: "0",
                            onhold: "0",
                            escalated: "0",
                            working: "0",
                            resolved: "0",
                            total: "0",
                        };
                    }

                    const status = item.Status.toLowerCase();

                    subDivisionMap[code][status] = (
                        parseInt(subDivisionMap[code][status] || 0) +
                        parseInt(item.TotalCount || 0)
                    ).toString();
                });

                const subDivisions = Object.values(subDivisionMap).map((sub) => {
                    const total =
                        parseInt(sub.pending || 0) +
                        parseInt(sub.allocated || 0) +
                        parseInt(sub.onhold || 0) +
                        parseInt(sub.escalated || 0) +
                        parseInt(sub.working || 0) +
                        parseInt(sub.resolved || 0);
                    return { ...sub, total: total.toString() };
                });

                // ✅ Add subchildren under the correct division
                setParentData((prev) =>
                    prev.map((parent) => ({
                        ...parent,
                        children: parent.children.map((division) =>
                            division.Code === divisionCode
                                ? { ...division, subchildren: subDivisions }
                                : division
                        ),
                    }))
                );
            }
        } catch (error) {
            console.error(`Error fetching subdivisions for division ${divisionCode}:`, error);
        } finally {
            setLoading((prev) => ({
                ...prev,
                subchildren: { ...prev.subchildren, [divisionCode]: false },
            }));
        }
    };

    const renderHierarchy = () => {
        if (loading.parents) {
            return (
                <div style={{ textAlign: "center", padding: "60px 0" }}>
                    <CircularProgress size={50} />
                    <p style={{ marginTop: "16px", color: "#666", fontSize: "14px" }}>
                        Loading circles...
                    </p>
                </div>
            );
        }

        if (!parentData || parentData.length === 0) {
            return <div style={{ textAlign: "center", padding: "40px", color: "#888" }}>
                No data available
            </div>;
        }

        return parentData.map((parent, parentIndex) => {
            // For admin users (hierarchy === 1), show all circles even with 0 complaints
            // For other hierarchies, hide circles with 0 complaints and no children
            if (hierarchy !== 1 && parseInt(parent.total) === 0 && (!parent.children || parent.children.length === 0)) {
                return null;
            }

            return (
                <div
                    key={parentIndex}
                    style={{
                        backgroundColor: "white",
                        marginBottom: "10px",
                        padding: "10px",
                        borderRadius: "10px",
                        borderLeft: `15px solid ${getColor(parentIndex)}`,
                        cursor: "pointer",
                        width: "90%",
                        alignSelf: "center",
                    }}
                    onClick={() => {
                        dispatch(updateHomeButton(false));
                        toggleParent(parent, parentIndex);
                        setCircleName(parent.name);
                        setDivisionName("");
                        setSubDivision("");

                        // For hierarchy 4, don't reset children as they are already fetched
                        if (hierarchy !== 4) {
                            setParentData((prev) =>
                                prev.map((p, i) =>
                                    i === parentIndex ? { ...p, children: [] } : p
                                )
                            );
                            fetchDivisions(parent.Code);
                        }
                        // Fetch lineman/field staff for this circle when drilling up
                        getFieldStaffBySubdivision(parent.Code);
                        // Clear APMS when drilling up to circle level
                        setConnections(null);

                        dispatch(updateOC({ officeCode: parseInt(parent.Code, 10) }));
                        setCode1(parent.Code);
                        setDivisionCodeData('');
                        setCircleCodeData(parent.Code);
                        updateStats(parent);
                    }}
                >

                    {(hierarchy === 1 || hierarchy === 2 || hierarchy === 3) && (
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between", cursor: "pointer", alignItems: "center" }}>
                                <p style={{ color: "#580AFF" }}>{parent.name} {"Circle"}</p>
                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    {weatherData[parent.Code] && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                            <img
                                                src={`https://openweathermap.org/img/wn/${weatherData[parent.Code].icon}.png`}
                                                alt="weather"
                                                style={{ width: 25, height: 25 }}
                                            />
                                            <span style={{ fontSize: "12px", fontWeight: "bold", color: "#FF6B35" }}>
                                                {weatherData[parent.Code].temp}°C
                                            </span>
                                        </div>
                                    )}
                                    {openParentIndex === parentIndex ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Pending</p>
                                    <p style={{ fontSize: "18px", color: "red", textAlign: "center" }}>{parent.pending || "0"}</p>
                                </div>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>In Process</p>
                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>
                                        {(parseInt(parent.allocated || 0) + parseInt(parent.onhold || 0) + parseInt(parent.working || 0)).toString()}
                                    </p>
                                </div>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Resolved</p>
                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{parent.resolved || "0"}</p>
                                </div>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Total</p>
                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{parent.total}</p>
                                </div>
                            </div>
                        </div>
                    )}
                    {hierarchy === 4 && (
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between", cursor: "pointer", alignItems: "center" }}>
                                <p style={{ color: "#296fff" }}>{parent.name} {"Divisions"}</p>
                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    {weatherData[parent.Code] && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                            <img
                                                src={`https://openweathermap.org/img/wn/${weatherData[parent.Code].icon}.png`}
                                                alt="weather"
                                                style={{ width: 25, height: 25 }}
                                            />
                                            <span style={{ fontSize: "12px", fontWeight: "bold", color: "#FF6B35" }}>
                                                {weatherData[parent.Code].temp}°C
                                            </span>
                                        </div>
                                    )}
                                    {openParentIndex === parentIndex ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Pending</p>
                                    <p style={{ fontSize: "18px", color: "red", textAlign: "center" }}>{parent.pending || "0"}</p>
                                </div>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>In Process</p>
                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>
                                        {(parseInt(parent.allocated || 0) + parseInt(parent.onhold || 0) + parseInt(parent.working || 0)).toString()}
                                    </p>
                                </div>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Resolved</p>
                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{parent.resolved || "0"}</p>
                                </div>
                                <div>
                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Total</p>
                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{parent.total}</p>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Division Level Children (Subdivisions) */}
                    {hierarchy === 4 && openParentIndex === parentIndex && (
                        <div style={{ marginLeft: "20px", backgroundColor: "#f8f8f8", borderRadius: 8, marginTop: 20, border: "3px solid black", boxShadow: "10px 10px" }}>
                            {parent.children && parent.children.length > 0 ? (
                                parent.children
                                    .filter((child) => parseInt(child.total) > 0)
                                    .map((child, childIndex) => (
                                        <div
                                            key={childIndex}
                                            style={{
                                                marginBottom: "5px",
                                                padding: "10px",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                                backgroundColor: selectedOffice === child.Code ? "#EEF1F7" : "transparent",
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                console.log("=== SUBDIVISION CLICKED (Hierarchy 4) ===");
                                                console.log("child.Code:", child.Code);
                                                console.log("roleTypeId:", roleTypeId);
                                                dispatch(updateOC({ officeCode: parseInt(child.Code, 10) }));
                                                setCode1(child.Code);
                                                setSubDivision(child.Code);
                                                // Set circle and division codes for proper filtering in map
                                                setCircleCodeData(child.Code.toString().slice(0, 3));
                                                setDivisionCodeData(child.Code.toString().slice(0, 4));
                                                updateStats(child);
                                                // Fetch GeoJson for subdivision lines
                                                console.log("Dispatching fetchGeoJson with subDivisionCode:", child.Code);
                                                dispatch(fetchGeoJson({ subDivisionCode: child.Code, roleTypeId })).then((result) => {
                                                    console.log("fetchGeoJson result:", result);
                                                }).catch((error) => {
                                                    console.error("fetchGeoJson error:", error);
                                                });
                                                // Fetch lineman/field staff for this subdivision
                                                getFieldStaffBySubdivision(child.Code);
                                                // Fetch complaints for this subdivision
                                                dispatch(fetchPaginatedAllComplaints({
                                                    pageSize: complaintsPageSize,
                                                    pageNumber: complaintsPageNumber,
                                                    subDivisionCode: child.Code,
                                                    dateFrom: convertDateYYYYMMDD(yesterdayDate),
                                                    dateTo: convertDateYYYYMMDD(new Date())
                                                }));
                                                // Clear old APMS first, then fetch new APMS for this subdivision
                                                setConnections(null);
                                                if (mdmToken) {
                                                    getAPMSCoordinates(mdmToken.privatekey, child.Code.toString().slice(0, 5));
                                                }
                                            }}
                                        >
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <p style={{ color: "#0000ff" }}>{child.name} {"Sub Division"}</p>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Pending</p>
                                                    <p style={{ fontSize: "18px", color: "red", textAlign: "center" }}>{child.pending || "0"}</p>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>In Process</p>
                                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>
                                                        {(parseInt(child.allocated || 0) + parseInt(child.onhold || 0) + parseInt(child.working || 0)).toString()}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Resolved</p>
                                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{child.resolved || "0"}</p>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Total</p>
                                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{child.total}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                            ) : (
                                <p style={{ color: "#6A6A6A", textAlign: "center" }}>No subdivisions available</p>
                            )}
                        </div>
                    )}
                    {(hierarchy === 1 || hierarchy === 2 || hierarchy === 3) && openParentIndex === parentIndex && (
                        <div style={{ marginLeft: "20px", backgroundColor: "#f8f8f8", borderRadius: 8, marginTop: 20, border: "3px solid black", boxShadow: "10px 10px" }}>
                            {loading.children[parent.Code] ? (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
                                    <CircularProgress />
                                </div>
                            ) : parent.children && parent.children.length > 0 ? (
                                parent.children
                                    .filter((child) => parseInt(child.total) > 0 || (child.subchildren && child.subchildren.length > 0))
                                    .map((child, childIndex) => (
                                        <div
                                            key={childIndex}
                                            style={{
                                                marginBottom: "5px",
                                                padding: "10px",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleChild(parentIndex, childIndex, child);
                                                setDivisionName(child.name);
                                                dispatch(updateOC({ officeCode: parseInt(child.Code, 10) }));
                                                setPendingStats(child.pending);
                                                setAllocatedStats(child.allocated);
                                                setOnholdStats(child.onhold);
                                                setEscalatedStats(child.escalated);
                                                setResolvedStats(child.resolved);
                                                setTotalComplaints(child.total);
                                                setSubDivision("");
                                                if (!child.subchildren || child.subchildren.length === 0) {
                                                    fetchSubDivisions(parent.Code, child.Code);
                                                }
                                                // Fetch lineman/field staff for this division when drilling up from subdivision
                                                getFieldStaffBySubdivision(child.Code);
                                                // Clear APMS when drilling up to division level
                                                setConnections(null);

                                                setCircleCodeData('')
                                                setDivisionCodeData(child.Code)
                                                updateStats(child);
                                            }}
                                        >
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <p style={{ color: "#296fff" }}>{child.name} {"Division"}</p>
                                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                    {weatherData[child.Code] && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                                            <img
                                                                src={`https://openweathermap.org/img/wn/${weatherData[child.Code].icon}.png`}
                                                                alt="weather"
                                                                style={{ width: 22, height: 22 }}
                                                            />
                                                            <span style={{ fontSize: "11px", fontWeight: "bold", color: "#FF6B35" }}>
                                                                {weatherData[child.Code].temp}°C
                                                            </span>
                                                        </div>
                                                    )}
                                                    {openChildIndexes[parentIndex] === childIndex ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Pending</p>
                                                    <p style={{ fontSize: "18px", color: "red", textAlign: "center" }}>{child.pending || "0"}</p>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>In Process</p>
                                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>
                                                        {(parseInt(child.allocated || 0) + parseInt(child.onhold || 0) + parseInt(child.working || 0)).toString()}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Resolved</p>
                                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{child.resolved || "0"}</p>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Total</p>
                                                    <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{child.total}</p>
                                                </div>
                                            </div>
                                            {openChildIndexes[parentIndex] === childIndex && (
                                                <div
                                                    style={{
                                                        marginLeft: "20px",
                                                        marginTop: "10px",
                                                        backgroundColor: "white",
                                                        borderRadius: 8,
                                                        border: "3px solid grey",
                                                    }}
                                                >
                                                    {loading.subchildren[child.Code] ? (
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
                                                            <CircularProgress />
                                                        </div>
                                                    ) : child.subchildren?.length > 0 ? (
                                                        child.subchildren
                                                            .filter((subchild) => parseInt(subchild.total) > 0)
                                                            .map((subchild, subChildIndex) => (
                                                                <div
                                                                    key={subChildIndex}
                                                                    style={{
                                                                        marginBottom: "5px",
                                                                        padding: "10px",
                                                                        borderRadius: "5px",
                                                                        cursor: "pointer",
                                                                        backgroundColor: selectedOffice === subchild.Code ? "#EEF1F7" : "transparent",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();

                                                                        dispatch(updateOC({ officeCode: parseInt(subchild.Code, 10) }));
                                                                        toggleSubChild(parentIndex, childIndex, subChildIndex);

                                                                        setPendingStats(subchild.pending);
                                                                        setAllocatedStats(subchild.allocated);
                                                                        setOnholdStats(subchild.onhold);
                                                                        setEscalatedStats(subchild.escalated);
                                                                        setResolvedStats(subchild.resolved);
                                                                        setTotalComplaints(subchild.total);
                                                                        setCode1(subchild.Code);
                                                                        setSubDivision(subchild.Code);
                                                                        updateStats(subchild);

                                                                        // Fetch GeoJSON for subdivision lines
                                                                        dispatch(fetchGeoJson({ subDivisionCode: subchild.Code, roleTypeId }));
                                                                        // Fetch lineman/field staff for this subdivision
                                                                        getFieldStaffBySubdivision(subchild.Code);
                                                                        // Clear old APMS first, then fetch new APMS for this subdivision
                                                                        setConnections(null);
                                                                        if (mdmToken) {
                                                                            getAPMSCoordinates(mdmToken.privatekey, subchild.Code.toString().slice(0, 5));
                                                                        }
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                        <p style={{ color: "#0000ff" }}>{subchild.name} {"Sub Division"}</p>
                                                                    </div>
                                                                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                                                                        <div>
                                                                            <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Pending</p>
                                                                            <p style={{ fontSize: "18px", color: "red", textAlign: "center" }}>{subchild.pending || "0"}</p>
                                                                        </div>
                                                                        <div>
                                                                            <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>In Process</p>
                                                                            <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>
                                                                                {(parseInt(subchild.allocated || 0) +
                                                                                    parseInt(subchild.onhold || 0) +
                                                                                    parseInt(subchild.working || 0)).toString()}
                                                                            </p>
                                                                        </div>
                                                                        <div>
                                                                            <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Resolved</p>
                                                                            <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{subchild.resolved || "0"}</p>
                                                                        </div>
                                                                        <div>
                                                                            <p style={{ fontSize: "13px", color: "#6A6A6A", textAlign: "center" }}>Total</p>
                                                                            <p style={{ fontSize: "18px", color: "grey", textAlign: "center" }}>{subchild.total}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                    ) : (
                                                        <p style={{ color: "#6A6A6A", textAlign: "center" }}></p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))
                            ) : (
                                <p style={{ color: "#6A6A6A", textAlign: "center" }}>No divisions available</p>
                            )}
                        </div>
                    )}
                </div>
            );
        });
    };


    useEffect(() => {
        const fetchInitialData = async () => {
            // Skip refetch if we already have data
            if (parentData && parentData.length > 0) {
                setIsLoading(false);
                return;
            }

            setIsLoading(true);

            if (hierarchy == 1 || hierarchy == 2 || hierarchy == 3 || hierarchy == 4) {
                await fetchCircles();
                // Load linemen for the initial hierarchy level
                getFieldStaffCoordinates();
                setIsLoading(false);
            } else {
                getDataStats()
            }
        };
        fetchInitialData();
    }, [disco, hierarchy]);


    if (childData[circleCode]?.length > 0) {
        setParentData((prev) =>
            prev.map((parent) =>
                parent.Code === circleCode ? { ...parent, children: childData[circleCode] } : parent
            )
        );
        return;
    }

    const truncateText = (text, maxLength) => {
        if (!text) return ""; // Handle undefined or empty values

        const trimmedText = text.trim(); // Trim any extra spaces
        let truncated = trimmedText.length > maxLength ? trimmedText.substring(0, maxLength) + "..." : trimmedText;

        return truncated;
    };

    const handleDisco = (e) => {
        const newDisco = e.target.value;
        discoRef.current = newDisco; // Update ref immediately
        setDisco(newDisco);
        // Reset data when DISCO changes
        setParentData([]);
        setLoading(prev => ({ ...prev, parents: true }));
        setIsLoading(true);
        setStatsLoading(true);
        setFieldStaff([]);
        setComplaints([]);
        setPendingStats(0);
        setAllocatedStats(0);
        setOnholdStats(0);
        setEscalatedStats(0);
        setWorkingStats(0);
        setResolvedStats(0);
        setTotalComplaints(0);
        // Reset drill-down state when company changes
        setSubDivision('');
        setCircleCodeData('');
        setDivisionCodeData('');
        setCircleName('');
        setDivisionName('');
        setOpenParentIndex(null);
        setOpenChildIndexes({});
        setOpenSubChildIndexes({});
        setConnections(null);
        // Reset home button state to true (company level - no filtering)
        dispatch(updateHomeButton(true));
    }

    // Back to company level for hierarchy 1
    const handleBackToCompany = async () => {
        setOpenParentIndex(null);
        setOpenChildIndexes({});
        setOpenSubChildIndexes({});
        setCircleName('');
        setDivisionName('');
        setSubDivision('');
        setConnections(null);
        setCircleCodeData('');
        setDivisionCodeData('');
        setCode1(disco);

        // Reset home button state to true (company level - no filtering)
        dispatch(updateHomeButton(true));

        // Reset lineman selection and restore company-level cached data (no API calls)
        setSelectedLineman('');
        setUserIds(companyUserIds);
        setFieldStaff(companyFieldStaff);

        // Update stats to show company level totals using cached parentData
        if (parentData && parentData.length > 0) {
            let totalPending = 0, totalAllocated = 0, totalOnhold = 0, totalEscalated = 0, totalWorking = 0, totalResolved = 0;
            parentData.forEach(circle => {
                totalPending += parseInt(circle.pending || 0);
                totalAllocated += parseInt(circle.allocated || 0);
                totalOnhold += parseInt(circle.onhold || 0);
                totalEscalated += parseInt(circle.escalated || 0);
                totalWorking += parseInt(circle.working || 0);
                totalResolved += parseInt(circle.resolved || 0);
            });
            setPendingStats(totalPending);
            setAllocatedStats(totalAllocated);
            setOnholdStats(totalOnhold);
            setEscalatedStats(totalEscalated);
            setWorkingStats(totalWorking);
            setResolvedStats(totalResolved);
            setTotalComplaints(totalPending + totalAllocated + totalOnhold + totalEscalated + totalWorking + totalResolved);
        }

        // Fetch company-level geoJSON for proper map rendering
        await dispatch(fetchGeoJson({ subDivisionCode: disco, roleTypeId }));

        setIsLoading(false);
    }

    return (
        <>
            <div className='form-box' style={{ marginTop: '4rem' }}>
                <div style={{ display: 'flex', height: '91vh' }}>
                    <div style={{
                        display: 'flex', flexDirection: 'column', gap: 10, width: '75%', height: '100%', paddingTop: 10, borderRadius: 50
                    }}>
                        {

                            <div style={{ flex: 1, position: 'relative', visibility: ((geoJSON || geoJSONDivision || circleCode || divisionCode || fieldStaff) && result1) ? 'visible' : 'hidden' }}>
                                {/* Loading overlay for map */}
                                {geoJsonLoading && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 1000,
                                        borderRadius: 8
                                    }}>
                                        <div style={{
                                            width: 50,
                                            height: 50,
                                            border: '4px solid #f3f3f3',
                                            borderTop: '4px solid #3498db',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite'
                                        }} />
                                        <p style={{ color: 'white', marginTop: 15, fontSize: 16 }}>Loading Map...</p>
                                        <style>
                                            {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
                                        </style>
                                    </div>
                                )}
                                {hierarchy === 1 && !geoJsonLoading && (isLoading || statsLoading) && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 1000,
                                        borderRadius: 8
                                    }}>
                                        <div style={{
                                            width: 50,
                                            height: 50,
                                            border: '4px solid #f3f3f3',
                                            borderTop: '4px solid #3498db',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite'
                                        }} />
                                        <p style={{ color: 'white', marginTop: 15, fontSize: 16 }}>Loading Data...</p>
                                        <style>
                                            {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                                            .hide-scrollbar::-webkit-scrollbar { display: none; }`}
                                        </style>
                                    </div>
                                )}
                                <Map
                                    key={`map-${disco}`}
                                    connections={connections}
                                    selectedMarker1={selectedMarker2}
                                    setSubDivision={subDivision}
                                    complaints={complaints}
                                    handleSubmit={handleSubmit}
                                    onComplaintsUpdate={handleComplaintsFromChild}
                                    updateSelectedMarker1={updateSelectedMarker1}
                                    setCode={circleName}
                                    setDivision={divisionName}
                                    company={companyName}
                                    fieldStaff={fieldStaff}
                                    circleCodeData={circleCode}
                                    DivisionCodeData={divisionCode}
                                    hierarchyCode={code1}
                                    circleCode={circleCodeData}
                                    divisionCode={divisionCodeData}
                                    complaintData={parentData}
                                    weatherData={weatherData}
                                    parentData={parentData}
                                />
                            </div>
                        }
                        <div style={{ background: '#003971', width: '99%', height: 30, justifyContent: 'space-between', padding: 10, borderRadius: 8, justifyContent: 'space-between' }}>
                            {statsLoading ? (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <CircularProgress size={24} style={{ color: 'white' }} />
                                </div>
                            ) : (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => getDataStats('1')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Pending : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{pendingStats ? pendingStats : '0'}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => getDataStats('2')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Allocated : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{allocatedStats ? allocatedStats : '0'}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => getDataStats('7')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Working : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{workingStats ? workingStats : '0'}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => getDataStats('3')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>On-Hold : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{onholdStats ? onholdStats : '0'}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => getDataStats('4')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Escalated : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{escalatedStats ? escalatedStats : '0'}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => getDataStats('5')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Resolved : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{resolvedStats ? resolvedStats : '0'}</p>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => getDataStats('6')} >
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Total : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{totalComplaints ? totalComplaints : '0'}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>


                    {
                        hierarchy == '52' ?
                            isLoading ? (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100vh',
                                    width: "25%"
                                }}>
                                    <CircularProgress />
                                </div>
                            ) : (
                                <div style={{
                                    display: 'flex', flexDirection: 'column', width: '25%', height: '100%', marginTop: 20
                                }}>
                                    {/* Daily Performance Snapshot - Hidden
                                    {(() => {
                                        const snapshot = getDailySnapshot();
                                        return (
                                            <div style={{
                                                background: 'linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)',
                                                borderRadius: 10,
                                                padding: '12px 15px',
                                                margin: '10px 0px 10px 10px',
                                                width: '98%'
                                                // boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    marginBottom: 10,
                                                    marginTop: 10
                                                }}>
                                                    <span style={{ color: '#FBE451', fontSize: 14, fontWeight: 700 }}>Today's Summary</span>
                                                    <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 10 }}>{new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}</span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                                                    <div style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                                                        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 9, marginBottom: 2 }}>Received</div>
                                                        <div style={{ color: 'white', fontSize: 18, fontWeight: 700 }}>{snapshot.received}</div>
                                                    </div>
                                                    <div style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                                                        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 9, marginBottom: 2 }}>Resolved</div>
                                                        <div style={{ color: '#4ade80', fontSize: 18, fontWeight: 700 }}>{snapshot.resolved}</div>
                                                    </div>
                                                    <div style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                                                        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 9, marginBottom: 2 }}>Pending</div>
                                                        <div style={{ color: '#fbbf24', fontSize: 18, fontWeight: 700 }}>{snapshot.received - snapshot.resolved}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })()} */}
                                    {/* Complaints Section */}
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flexGrow: 1,
                                        maxHeight: connections && connections.length > 0 ? '65%' : '100%',
                                        minHeight: 'auto'
                                    }}>
                                        <div style={{ backgroundColor: '#003971', color: 'white', padding: '8px 15px', margin: '10px 0px 0px 10px', borderRadius: '8px 8px 0 0', fontWeight: 'bold' }}>
                                            Technical Complaints
                                        </div>
                                        <div style={{ backgroundColor: 'white', display: 'flex', borderRadius: '0 0 10px 10px', padding: '5px', border: '1px solid grey', margin: '0px 0px 0px 10px' }}>
                                            <input
                                                type="text"
                                                value={complaintSearchFormik.values.iv_search_tracking_id}
                                                name="iv_search_tracking_id"
                                                onChange={complaintSearchFormik.handleChange}
                                                onBlur={complaintSearchFormik.handleBlur}
                                                style={{
                                                    width: '100%',
                                                    padding: '5px 10px',
                                                    border: '1px solid white',
                                                    backgroundColor: 'transparent',
                                                    outline: 'none'
                                                }}
                                            />
                                            <SearchIcon
                                                sx={{
                                                    backgroundColor: '#09669d',
                                                    color: 'white',
                                                    width: 35,      // Adjust width as desired
                                                    height: 35,     // Adjust height as desired
                                                    borderRadius: '10px', // Optional: to make it a circular icon
                                                    padding: '4px', // Optional: for inner spacing if background is rounded
                                                    cursor: 'pointer'
                                                }}
                                                onClick={complaintSearchFormik.handleSubmit}
                                            />
                                        </div>
                                        <p style={{ color: 'red', margin: '5px 0px 0px 10px', fontSize: 'small' }}>
                                            {
                                                complaintSearchFormik.errors.iv_search_tracking_id ? complaintSearchFormik.errors.iv_search_tracking_id : ''
                                            }
                                        </p>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-around',
                                            alignItems: 'center',
                                            background: '#003971',
                                            padding: '8px 10px',
                                            borderRadius: '8px',
                                            margin: '10px 0px 5px 10px',
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <img src={redCircle} alt="pending" width={12} />
                                                <span style={{ color: 'white', fontSize: '14px' }}>Pending: </span>
                                                <span style={{ color: '#FBE451', fontSize: '14px', fontWeight: 'bold' }}>{pendingStats || '0'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <img src={blue_Circle} alt="allocated" width={12} />
                                                <span style={{ color: 'white', fontSize: '14px' }}>Allocated: </span>
                                                <span style={{ color: '#FBE451', fontSize: '14px', fontWeight: 'bold' }}>{allocatedStats || '0'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <img src={orange} alt="onhold" width={12} />
                                                <span style={{ color: 'white', fontSize: '14px' }}>On-Hold: </span>
                                                <span style={{ color: '#FBE451', fontSize: '14px', fontWeight: 'bold' }}>{onholdStats || '0'}</span>
                                            </div>
                                        </div>
                                        <div style={{
                                            display: 'flex', flexDirection: 'column',
                                            color: 'white', overflowY: 'auto',
                                            margin: '5px 0px 10px 10px',
                                            borderRadius: 10, flex: 1,
                                            paddingRight: '2px',
                                        }}>
                                            {
                                                finalSortedComplaints.map((item, index) => {
                                                    return (
                                                        ((item.Status === 'Pending' || item.Status === 'Allocated' || item.Status === 'onhold' || item.Status === 'OnHold' || item.Status === 'Onhold')) &&
                                                        <div
                                                            key={index}
                                                            style={{
                                                                width: '100%',
                                                                backgroundColor: 'white',
                                                                cursor: 'pointer',
                                                                position: 'relative',
                                                                marginBottom: '10px',
                                                            }}
                                                            onClick={() => handleOpenPopup(item)}
                                                            onMouseEnter={() => {
                                                                setHoveredIndex(index);
                                                            }}
                                                            onMouseLeave={() => {
                                                                setHoveredIndex(null);
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    backgroundColor:
                                                                        (item.T1Priority === 'VIP' ||
                                                                            item.T1Priority === 'Vip' ||
                                                                            item.T1Priority === 'vip')
                                                                            ? '#FCEBEB'
                                                                            : '#D5E5FF',
                                                                    margin: '1%',
                                                                    padding: '10px',
                                                                    borderRadius: '10px',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <div>
                                                                    {item.Status === 'Pending' ? (
                                                                        <img src={redCircle} alt="off" width={15} />
                                                                    ) : item.Status === 'Allocated' ? (
                                                                        <img src={blue_Circle} alt="off" width={15} />
                                                                    ) : (
                                                                        (item.Status === 'onhold' || item.Status === 'Onhold' || item.Status === 'OnHold') && <img src={orange} alt="off" width={15} />
                                                                    )}
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        paddingLeft: '12px',
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        width: '100%',
                                                                    }}
                                                                >
                                                                    <div style={{ width: '33%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <p style={{ fontSize: '12px', color: 'black' }}>{item.RefNo}</p>
                                                                    </div>
                                                                    <div style={{ width: '33%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <p style={{ fontSize: '12px', color: 'black', textAlign: 'center' }}>
                                                                            {truncateText(item.ComplaintType, 25)}
                                                                        </p>
                                                                    </div>
                                                                    <div style={{ fontSize: '12px', width: '33%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <RemainingTime
                                                                            startTime={item.RegisteredAt}
                                                                            fontSize={'12px'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    {item.Source?.startsWith('e') ? (
                                                                        <img src={eopsIcons} style={{ width: 25, height: 20 }} />
                                                                    ) : item.Source === 'nepra' ? (
                                                                        <img src={nepraIcon} style={{ width: 40, height: 40 }} />
                                                                    ) : (item.Source?.startsWith('CCMS') || item.Source?.startsWith('Call')) ? (
                                                                        <img src={callCenter} style={{ width: 25, height: 20 }} />
                                                                    ) : (item.Source?.toLowerCase().includes('smart') && (
                                                                        <img src={cellIcon} style={{ width: 25, height: 30 }} />
                                                                    )
                                                                    )}
                                                                </div>

                                                            </div>
                                                            {hoveredIndex === index && (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-30px',
                                                                        left: '50%',
                                                                        transform: 'translateX(-50%)',
                                                                        backgroundColor: '#333',
                                                                        color: 'white',
                                                                        padding: '5px 10px',
                                                                        borderRadius: '5px',
                                                                        fontSize: '12px',
                                                                        whiteSpace: 'nowrap',
                                                                        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
                                                                        zIndex: 10,
                                                                    }}
                                                                >
                                                                    {`Status: ${item.Status === 'Pending' ? "Pending" : item.Status === 'Allocated' ? "Allocated" : item.Status === 'onhold' && "OnHold"}`}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>

                                    {/* APMS Complaints Section */}
                                    {apmsComplaints && apmsComplaints.length > 0 && (
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            maxHeight: '40%',
                                            minHeight: 'auto',
                                            marginTop: '0px'
                                        }}>
                                            <div style={{ backgroundColor: '#003971', color: 'white', padding: '8px 15px', margin: '0px 0px 0px 10px', borderRadius: '8px 8px 0 0', fontWeight: 'bold' }}>
                                                APMS Complaints
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-around',
                                                alignItems: 'center',
                                                background: '#003971',
                                                padding: '8px 10px',
                                                margin: '0px 0px 0px 10px',
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <img src={redCircle} alt="pending" width={12} />
                                                    <span style={{ color: 'white', fontSize: '14px' }}>Pending: </span>
                                                    <span style={{ color: '#FBE451', fontSize: '14px', fontWeight: 'bold' }}>{apmsPendingStats || '0'}</span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <img src={blue_Circle} alt="allocated" width={12} />
                                                    <span style={{ color: 'white', fontSize: '14px' }}>Allocated: </span>
                                                    <span style={{ color: '#FBE451', fontSize: '14px', fontWeight: 'bold' }}>{apmsAllocatedStats || '0'}</span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <img src={orange} alt="onhold" width={12} />
                                                    <span style={{ color: 'white', fontSize: '14px' }}>On-Hold: </span>
                                                    <span style={{ color: '#FBE451', fontSize: '14px', fontWeight: 'bold' }}>{apmsOnholdStats || '0'}</span>
                                                </div>
                                            </div>
                                            <div style={{
                                                display: 'flex', flexDirection: 'column',
                                                color: 'white', overflowY: 'auto',
                                                margin: '0px 0px 10px 10px',
                                                borderRadius: '0 0 10px 10px',
                                                flex: 1,
                                                maxHeight: '350px',
                                                backgroundColor: 'white',
                                            }}>
                                                {apmsComplaints
                                                    .filter(c => c.status === 'Pending' || c.status === 'Allocated' || c.status === 'Onhold' || c.status === 'OnHold')
                                                    .sort((a, b) => {
                                                        const order = { 'Pending': 1, 'Allocated': 2, 'Onhold': 3, 'OnHold': 3 };
                                                        return (order[a.status] || 4) - (order[b.status] || 4);
                                                    })
                                                    .map((item, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            width: '100%',
                                                            backgroundColor: 'white',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => handleOpenApmsPopup(item)}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                backgroundColor: '#FFE4B5',
                                                                margin: '1%',
                                                                padding: '10px',
                                                                borderRadius: '10px',
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <div>
                                                                {item.status === 'Pending' ? (
                                                                    <img src={redCircle} alt="pending" width={15} />
                                                                ) : item.status === 'Allocated' ? (
                                                                    <img src={blue_Circle} alt="allocated" width={15} />
                                                                ) : (
                                                                    <img src={orange} alt="onhold" width={15} />
                                                                )}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    paddingLeft: '12px',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div style={{ width: '40%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                                    <p style={{ fontSize: '11px', color: 'black', margin: 0 }}>{item.apmsMeterSerialNo}</p>
                                                                </div>
                                                                <div style={{ width: '30%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <p style={{ fontSize: '11px', color: 'black', textAlign: 'center', margin: 0 }}>
                                                                        {item.complaintTypeName}
                                                                    </p>
                                                                </div>
                                                                <div style={{ fontSize: '10px', width: '30%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                                    <span style={{ color: 'black' }}>{item.complaintCategoryName}</span>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginLeft: '8px' }}>
                                                                <img src={eopsIcons} style={{ width: 25, height: 20 }} alt="eops" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* APMS Card - Hidden
                                    {connections && connections.length > 0 && (
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flexGrow: 1,
                                            maxHeight: '30%',
                                            minHeight: 'auto',
                                        }}>
                                            <div style={{ backgroundColor: '#003971', color: 'white', padding: '8px 15px', margin: '10px 0px 0px 10px', borderRadius: '8px 8px 0 0', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span>APMS</span>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    <span style={{ backgroundColor: '#66FF66', color: 'black', padding: '2px 8px', borderRadius: '10px', fontSize: '12px' }}>
                                                        On: {connections ? connections.filter(item => item.contactor_status === 1).length : 0}
                                                    </span>
                                                    <span style={{ backgroundColor: '#f44336', color: 'white', padding: '2px 8px', borderRadius: '10px', fontSize: '12px' }}>
                                                        Off: {connections ? connections.filter(item => item.contactor_status === 0).length : 0}
                                                    </span>
                                                </div>
                                            </div>
                                            <div style={{
                                                display: 'flex', flexDirection: 'column',
                                                color: 'white', overflowY: 'auto',
                                                backgroundColor: 'white',
                                                borderRadius: '0 0 10px 10px',
                                                margin: '0px 0px 10px 10px',
                                                flex: 1,
                                                // border: '1px solid grey',
                                                borderRight: 'none',
                                            }}
                                            >
                                                {
                                                    connections &&
                                                    connections.filter(item => item.contactor_status === 0).map((item, index) => (
                                                        <div key={index}
                                                            style={{
                                                                width: '100%',
                                                            }} onClick={() => handleMarkerClick(item)}>
                                                            <div style={{ display: 'flex', backgroundColor: '#d5e5ff', margin: '1% 2% 1% 1%', padding: '10px', borderRadius: '10px', alignItems: 'center' }}>
                                                                <div>
                                                                    <img src={triangleoff} alt='off' width={25} />
                                                                </div>
                                                                <div style={{ marginLeft: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                                    <p style={{ fontSize: '11px', color: 'black', fontWeight: 'bold', margin: 0, width: '20%' }}>
                                                                        {item.name?.split('KVA')[0]?.trim()} KVA
                                                                    </p>
                                                                    <p style={{ fontSize: '11px', color: 'black', margin: 0, width: '50%', textAlign: 'center' }}>
                                                                        {item.name?.split('KVA')[1]?.trim() || item.address}
                                                                    </p>
                                                                    <p style={{ fontSize: '10px', color: 'black', margin: 0, width: '30%', textAlign: 'right' }}>{item.last_communication_time}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    )} */}
                                </div>
                            )
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', width: '25%', height: '100%' }}>
                                {(isLoading && !complaintData) ? (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100vh',
                                        width: '100%'
                                    }}>
                                        <CircularProgress />
                                    </div>
                                ) :
                                    complaintData
                                        ?
                                        <div style={{ marginTop: 20, textAlign: 'center', width: '100%', color: 'red', fontSize: '25px' }}>
                                            <p>No Data Found.</p>
                                        </div>
                                        :
                                        (
                                            <div style={{
                                                display: 'flex', flexDirection: 'column', width: '100%', height: 'calc(100vh - 120px)', overflowY: 'auto', overflowX: 'hidden', scrollbarWidth: 'none', msOverflowStyle: 'none'
                                            }} className="hide-scrollbar">
                                                {/* Daily Performance Snapshot - Collapsible - Only for Company level - Hidden */}
                                                {false && hierarchy == 2 && (() => {
                                                    const snapshot = getDailySnapshot();
                                                    return (
                                                        <div style={{ padding: '0 10px', marginBottom: 5, marginTop: 20, width: '98%' }}>
                                                            <div
                                                                onClick={() => setShowSummaryPanel(!showSummaryPanel)}
                                                                style={{
                                                                    background: showSummaryPanel ? 'linear-gradient(135deg, #1e3a5f, #2d5a87)' : 'linear-gradient(135deg, #2d5a87, #1e3a5f)',
                                                                    color: 'white',
                                                                    padding: '8px 12px',
                                                                    borderRadius: showSummaryPanel ? '8px 8px 0 0' : '8px',
                                                                    cursor: 'pointer',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    fontWeight: 600,
                                                                    fontSize: 13
                                                                }}
                                                            >
                                                                <span>Today's Summary</span>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                    <span style={{ fontSize: 10, opacity: 0.7 }}>{new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}</span>
                                                                    {showSummaryPanel ? <KeyboardArrowUp style={{ fontSize: 20 }} /> : <KeyboardArrowDown style={{ fontSize: 20 }} />}
                                                                </div>
                                                            </div>
                                                            {showSummaryPanel && (
                                                                <div style={{
                                                                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)',
                                                                    borderRadius: '0 0 8px 8px',
                                                                    padding: '12px'
                                                                }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                                                                        <div style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                                                                            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 9, marginBottom: 2 }}>Received</div>
                                                                            <div style={{ color: 'white', fontSize: 18, fontWeight: 700 }}>{snapshot.received}</div>
                                                                        </div>
                                                                        <div style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                                                                            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 9, marginBottom: 2 }}>Resolved</div>
                                                                            <div style={{ color: '#4ade80', fontSize: 18, fontWeight: 700 }}>{snapshot.resolved}</div>
                                                                        </div>
                                                                        <div style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                                                                            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 9, marginBottom: 2 }}>Pending</div>
                                                                            <div style={{ color: '#fbbf24', fontSize: 18, fontWeight: 700 }}>{snapshot.received - snapshot.resolved}</div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    {parentData && parentData.length > 0 && Object.keys(weatherData).length > 0 && (() => {
                                                                        const insights = getWeatherInsights();
                                                                        if (!insights) return null;

                                                                        return (
                                                                            <div style={{ marginTop: 12 }}>
                                                                                {/* Weather Impact Header */}
                                                                                <div style={{
                                                                                    color: 'rgba(255,255,255,0.9)',
                                                                                    fontSize: 11,
                                                                                    fontWeight: 600,
                                                                                    marginBottom: 8,
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: 6
                                                                                }}>
                                                                                    <span>Weather Impact</span>
                                                                                </div>

                                                                                {/* Stats Cards - 2x2 Grid */}
                                                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                                                                                    {/* Highest Load Card */}
                                                                                    {insights.worstCircle && (
                                                                                        <div style={{
                                                                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                                                            padding: '8px',
                                                                                            borderRadius: 8,
                                                                                            color: 'white',
                                                                                            boxShadow: '0 2px 8px rgba(102,126,234,0.3)'
                                                                                        }}>
                                                                                            <div style={{ fontSize: '7px', opacity: 0.85, marginBottom: 2 }}>HIGHEST LOAD</div>
                                                                                            <div style={{ fontWeight: 700, fontSize: '10px', marginBottom: 2 }}>{insights.worstCircle.name}</div>
                                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                                                <span style={{ fontSize: '14px', fontWeight: 700 }}>{insights.worstCircle.activeComplaints}</span>
                                                                                                <span style={{ fontSize: '8px', opacity: 0.85 }}>{insights.worstCircle.temp}°C</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Lowest Load Card */}
                                                                                    {insights.bestCircle && (
                                                                                        <div style={{
                                                                                            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                                                                            padding: '8px',
                                                                                            borderRadius: 8,
                                                                                            color: 'white',
                                                                                            boxShadow: '0 2px 8px rgba(16,185,129,0.3)'
                                                                                        }}>
                                                                                            <div style={{ fontSize: '7px', opacity: 0.85, marginBottom: 2 }}>LOWEST LOAD</div>
                                                                                            <div style={{ fontWeight: 700, fontSize: '10px', marginBottom: 2 }}>{insights.bestCircle.name}</div>
                                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                                                <span style={{ fontSize: '14px', fontWeight: 700 }}>{insights.bestCircle.activeComplaints}</span>
                                                                                                <span style={{ fontSize: '8px', opacity: 0.85 }}>{insights.bestCircle.temp}°C</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Hot Zones Card */}
                                                                                    <div style={{
                                                                                        background: 'linear-gradient(145deg, #ff6b6b, #ee5a5a)',
                                                                                        padding: '8px',
                                                                                        borderRadius: 8,
                                                                                        color: 'white',
                                                                                        boxShadow: '0 2px 8px rgba(238,90,90,0.3)'
                                                                                    }}>
                                                                                        <div style={{ fontSize: '14px', marginBottom: '2px' }}>🔥</div>
                                                                                        <div style={{ fontSize: '14px', fontWeight: 700 }}>{insights.avgHot}</div>
                                                                                        <div style={{ fontSize: '7px', opacity: 0.9 }}>Avg (Hot Zones)</div>
                                                                                    </div>

                                                                                    {/* Cool Zones Card */}
                                                                                    <div style={{
                                                                                        background: 'linear-gradient(145deg, #4ecdc4, #44a08d)',
                                                                                        padding: '8px',
                                                                                        borderRadius: 8,
                                                                                        color: 'white',
                                                                                        boxShadow: '0 2px 8px rgba(68,160,141,0.3)'
                                                                                    }}>
                                                                                        <div style={{ fontSize: '14px', marginBottom: '2px' }}>❄️</div>
                                                                                        <div style={{ fontSize: '14px', fontWeight: 700 }}>{insights.avgMild}</div>
                                                                                        <div style={{ fontSize: '7px', opacity: 0.9 }}>Avg (Cool Zones)</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                    {snapshot.circleRankings && snapshot.circleRankings.length > 0 && (() => {
                                                                        const getTempStyle = (temp) => {
                                                                            if (temp >= 40) return { color: '#d32f2f', bg: '#ffebee' };
                                                                            if (temp >= 35) return { color: '#e65100', bg: '#fff3e0' };
                                                                            if (temp >= 25) return { color: '#f57c00', bg: '#fff8e1' };
                                                                            return { color: '#2e7d32', bg: '#e8f5e9' };
                                                                        };

                                                                        const getConditionIcon = (desc) => {
                                                                            const d = desc?.toLowerCase() || '';
                                                                            if (d.includes('rain') || d.includes('storm')) return '🌧️';
                                                                            if (d.includes('cloud')) return '☁️';
                                                                            if (d.includes('haze') || d.includes('mist')) return '🌫️';
                                                                            if (d.includes('clear') || d.includes('sunny')) return '☀️';
                                                                            return '🌡️';
                                                                        };

                                                                        return (
                                                                            <div style={{ marginTop: 10 }}>
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', color: 'rgba(255,255,255,0.7)', fontSize: 9, marginBottom: 4, padding: '0 8px' }}>
                                                                                    <span>Circle Rankings <span style={{ color: '#fca5a5' }}>(Worst First)</span></span>
                                                                                    <div style={{ display: 'flex', gap: 4 }}>
                                                                                        <span style={{ width: 55, textAlign: 'right' }}>Res/Rec</span>
                                                                                        <span style={{ width: 35, textAlign: 'center' }}>Active</span>
                                                                                        {Object.keys(weatherData).length > 0 && (
                                                                                            <>
                                                                                                <span style={{ width: 35, textAlign: 'center' }}>Temp</span>
                                                                                                <span style={{ width: 55, textAlign: 'center' }}>Condition</span>
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    {snapshot.circleRankings.map((circle, idx) => {
                                                                                        const circleWeather = weatherData[circle.code] || null;
                                                                                        const tempStyle = circleWeather ? getTempStyle(circleWeather.temp) : null;
                                                                                        return (
                                                                                            <div key={circle.code} style={{
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                padding: '4px 8px',
                                                                                                marginBottom: 3,
                                                                                                background: idx === 0 ? 'rgba(220,38,38,0.25)' : 'rgba(255,255,255,0.08)',
                                                                                                borderRadius: 5,
                                                                                                borderLeft: idx === 0 ? '3px solid #fca5a5' : idx < 3 ? '3px solid #fbbf24' : '3px solid transparent'
                                                                                            }}>
                                                                                                <span style={{
                                                                                                    color: idx === 0 ? '#fca5a5' : idx < 3 ? '#fbbf24' : 'rgba(255,255,255,0.5)',
                                                                                                    fontSize: 10,
                                                                                                    fontWeight: 700,
                                                                                                    width: 18,
                                                                                                    flexShrink: 0
                                                                                                }}>#{idx + 1}</span>
                                                                                                <span style={{ color: 'white', fontSize: 10, fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingRight: 5 }}>{circle.name}</span>
                                                                                                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 9, width: 55, textAlign: 'right', flexShrink: 0 }}>{circle.resolved}/{circle.received}</span>
                                                                                                <span style={{
                                                                                                    color: idx === 0 ? '#fca5a5' : circle.active > 50 ? '#fbbf24' : '#4ade80',
                                                                                                    fontSize: 11,
                                                                                                    fontWeight: 700,
                                                                                                    width: 35,
                                                                                                    textAlign: 'center',
                                                                                                    flexShrink: 0
                                                                                                }}>{circle.active}</span>
                                                                                                {Object.keys(weatherData).length > 0 && (
                                                                                                    <>
                                                                                                        <span style={{
                                                                                                            width: 35,
                                                                                                            textAlign: 'center',
                                                                                                            flexShrink: 0,
                                                                                                            fontWeight: 700,
                                                                                                            fontSize: 9,
                                                                                                            color: tempStyle ? tempStyle.color : 'rgba(255,255,255,0.5)',
                                                                                                            backgroundColor: tempStyle ? tempStyle.bg : 'transparent',
                                                                                                            padding: '2px 4px',
                                                                                                            borderRadius: 4,
                                                                                                            marginLeft: 4
                                                                                                        }}>{circleWeather ? `${circleWeather.temp}°C` : '-'}</span>
                                                                                                        <span style={{
                                                                                                            width: 55,
                                                                                                            textAlign: 'center',
                                                                                                            flexShrink: 0,
                                                                                                            fontSize: 8,
                                                                                                            color: 'rgba(255,255,255,0.7)',
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            justifyContent: 'center',
                                                                                                            gap: 2,
                                                                                                            marginLeft: 4
                                                                                                        }}>
                                                                                                            {circleWeather ? (
                                                                                                                <>
                                                                                                                    <span>{getConditionIcon(circleWeather.description)}</span>
                                                                                                                    <span>{circleWeather.description?.split(' ')[0]}</span>
                                                                                                                </>
                                                                                                            ) : '-'}
                                                                                                        </span>
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })()}

                                                                    {/* Weather Impact Section - Stats Only */}
                                                                   
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })()}

                                                {/* Lineman Productivity Insights Panel */}
                                                {hierarchy != 1 && fieldStaff && fieldStaff.length > 0 && (
                                                    <></>
                                                    // <div style={{ padding: '0 10px', marginBottom: 5, width: '100%', boxSizing: 'border-box' }}>
                                                    //     <div
                                                    //         onClick={() => setShowLinemanPanel(!showLinemanPanel)}
                                                    //         style={{
                                                    //             background: showLinemanPanel ? 'linear-gradient(135deg, #059669, #047857)' : 'linear-gradient(135deg, #10b981, #059669)',
                                                    //             color: 'white',
                                                    //             padding: '8px 12px',
                                                    //             borderRadius: showLinemanPanel ? '8px 8px 0 0' : '8px',
                                                    //             cursor: 'pointer',
                                                    //             display: 'flex',
                                                    //             justifyContent: 'space-between',
                                                    //             alignItems: 'center',
                                                    //             fontSize: '13px',
                                                    //             fontWeight: 'bold',
                                                    //             width: '98%',
                                                    //             // boxSizing: 'border-box',
                                                    //         }}
                                                    //     >
                                                    //         <span>Lineman Productivity</span>
                                                    //         {showLinemanPanel ? <KeyboardArrowUp style={{ fontSize: 20 }} /> : <KeyboardArrowDown style={{ fontSize: 20 }} />}
                                                    //     </div>
                                                    //     {showLinemanPanel && (() => {
                                                    //         const insights = getLinemanInsights();
                                                    //         if (!insights) return null;
                                                    //         const dutyRate = insights.totalLinemen > 0 ? Math.round((userIds.length / insights.totalLinemen) * 100) : 0;

                                                    //         return (
                                                    //             <div style={{
                                                    //                 background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                                                    //                 borderRadius: '0 0 8px 8px',
                                                    //                 padding: '12px',
                                                    //                 width: '98%'
                                                    //             }}>
                                                    //                 {/* 2x2 Stats Grid */}
                                                    //                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
                                                    //                     {/* Total Card */}
                                                    //                     <div style={{
                                                    //                         background: 'linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)',
                                                    //                         borderRadius: 8,
                                                    //                         padding: '10px',
                                                    //                         boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                                    //                     }}>
                                                    //                         <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.7)', marginBottom: 2 }}>TOTAL LINEMEN</div>
                                                    //                         <div style={{ fontSize: 20, fontWeight: 700, color: 'white' }}>{insights.totalLinemen}</div>
                                                    //                     </div>

                                                    //                     {/* On Duty Card */}
                                                    //                     <div style={{
                                                    //                         background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                                    //                         borderRadius: 8,
                                                    //                         padding: '10px',
                                                    //                         boxShadow: '0 2px 8px rgba(59,130,246,0.3)'
                                                    //                     }}>
                                                    //                         <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.7)', marginBottom: 2 }}>ON DUTY</div>
                                                    //                         <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                                                    //                             <span style={{ fontSize: 20, fontWeight: 700, color: 'white' }}>{userIds.length}</span>
                                                    //                             <span style={{ fontSize: 10, color: '#93c5fd' }}>({dutyRate}%)</span>
                                                    //                         </div>
                                                    //                     </div>

                                                    //                     {/* Idle Card */}
                                                    //                     <div
                                                    //                         onClick={() => insights.idleLinemen.length > 0 && setShowIdleLinemanPopup(true)}
                                                    //                         style={{
                                                    //                             background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                                                    //                             borderRadius: 8,
                                                    //                             padding: '10px',
                                                    //                             boxShadow: '0 2px 8px rgba(239,68,68,0.3)',
                                                    //                             cursor: insights.idleLinemen.length > 0 ? 'pointer' : 'default'
                                                    //                         }}>
                                                    //                         <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.7)', marginBottom: 2 }}>IDLE (NO TASK)</div>
                                                    //                         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    //                             <span style={{ fontSize: 20, fontWeight: 700, color: 'white' }}>{insights.idleLinemen.length}</span>
                                                    //                             {insights.idleLinemen.length > 0 && <span style={{ fontSize: 9, color: 'rgba(255,255,255,0.8)' }}>View All →</span>}
                                                    //                         </div>
                                                    //                     </div>

                                                    //                     {/* Efficiency Card */}
                                                    //                     <div style={{
                                                    //                         background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                                                    //                         borderRadius: 8,
                                                    //                         padding: '10px',
                                                    //                         boxShadow: '0 2px 8px rgba(139,92,246,0.3)'
                                                    //                     }}>
                                                    //                         <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.7)', marginBottom: 2 }}>AVG EFFICIENCY</div>
                                                    //                         <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                                                    //                             <span style={{ fontSize: 20, fontWeight: 700, color: 'white' }}>
                                                    //                                 {insights.topPerformers.length > 0
                                                    //                                     ? Math.round(insights.topPerformers.reduce((a, b) => a + b.efficiency, 0) / insights.topPerformers.length)
                                                    //                                     : 0}%
                                                    //                             </span>
                                                    //                         </div>
                                                    //                     </div>
                                                    //                 </div>

                                                    //                 {/* Top 3 Performers - Horizontal */}
                                                    //                 {insights.topPerformers.length > 0 && (
                                                    //                     <div style={{
                                                    //                         background: 'rgba(0,0,0,0.15)',
                                                    //                         borderRadius: 8,
                                                    //                         padding: '8px'
                                                    //                     }}>
                                                    //                         <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.7)', marginBottom: 6, fontWeight: 600 }}>TOP PERFORMERS</div>
                                                    //                         <div style={{ display: 'flex', gap: 6 }}>
                                                    //                             {insights.topPerformers.slice(0, 3).map((l, i) => (
                                                    //                                 <div key={i} style={{
                                                    //                                     flex: 1,
                                                    //                                     background: 'rgba(255,255,255,0.1)',
                                                    //                                     borderRadius: 6,
                                                    //                                     padding: '6px 8px',
                                                    //                                     textAlign: 'center'
                                                    //                                 }}>
                                                    //                                     <div style={{ fontSize: 14, marginBottom: 2 }}>{i === 0 ? '🥇' : i === 1 ? '🥈' : '🥉'}</div>
                                                    //                                     <div style={{ color: 'white', fontSize: 9, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    //                                         {l.name?.split(' ')[0] || 'Unknown'}
                                                    //                                     </div>
                                                    //                                     <div style={{ color: '#4ade80', fontSize: 10, fontWeight: 700, marginTop: 2 }}>{l.resolved}</div>
                                                    //                                     <div style={{ fontSize: 7, color: 'rgba(255,255,255,0.6)' }}>resolved</div>
                                                    //                                 </div>
                                                    //                             ))}
                                                    //                         </div>
                                                    //                     </div>
                                                    //                 )}
                                                    //             </div>
                                                    //         );
                                                    //     })()}
                                                    // </div>
                                                )}
                                                {
                                                    hierarchy != 1 &&
                                                    <>
                                                        <div style={{ backgroundColor: 'white', display: 'flex', borderRadius: '10px', padding: '5px', border: '1px solid grey', margin: '10px 10px 0px 10px', width: '95%' }}>
                                                            <input
                                                                type="text"
                                                                value={complaintSearchFormik.values.iv_search_tracking_id}
                                                                name="iv_search_tracking_id"
                                                                onChange={complaintSearchFormik.handleChange}
                                                                onBlur={complaintSearchFormik.handleBlur}
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '5px 10px',
                                                                    border: '1px solid white',
                                                                    backgroundColor: 'transparent',
                                                                    outline: 'none'
                                                                }}
                                                            />
                                                            <SearchIcon
                                                                sx={{
                                                                    backgroundColor: '#09669d',
                                                                    color: 'white',
                                                                    width: 35,
                                                                    height: 35,
                                                                    borderRadius: '10px',
                                                                    padding: '4px',
                                                                    cursor: 'pointer'
                                                                }}
                                                                onClick={complaintSearchFormik.handleSubmit}
                                                            />
                                                        </div>
                                                        <p style={{ color: 'red', margin: '5px 0px 0px 10px', fontSize: 'small' }}>
                                                            {
                                                                complaintSearchFormik.errors.iv_search_tracking_id ? complaintSearchFormik.errors.iv_search_tracking_id : ''
                                                            }
                                                        </p>
                                                    </>
                                                }




                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    width: '100%',
                                                    padding: '5px 10px 0px 10px',
                                                    marginBottom: 10,
                                                    marginTop: hierarchy == 1 ? 20 : 0
                                                }}>
                                                    {
                                                        hierarchy == 1 &&
                                                        <>
                                                            <div style={{
                                                                backgroundColor: '#003971',
                                                                color: 'white',
                                                                padding: '8px 15px',
                                                                borderRadius: '8px 8px 0 0',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }}>
                                                                COMPANY
                                                            </div>
                                                            <Select
                                                                value={disco}
                                                                onChange={handleDisco}
                                                                displayEmpty
                                                                disabled={loading.parents || isLoading || statsLoading}
                                                                sx={{
                                                                    backgroundColor: 'white',
                                                                    borderRadius: '0 0 8px 8px',
                                                                    marginBottom: '10px',
                                                                    '& .MuiSelect-select': {
                                                                        padding: '10px 15px',
                                                                    },
                                                                    '&.Mui-disabled': {
                                                                        backgroundColor: '#f5f5f5',
                                                                    }
                                                                }}
                                                                fullWidth
                                                            >
                                                                <MenuItem value="11">LESCO - Lahore Electric Supply Company</MenuItem>
                                                                <MenuItem value="12">GEPCO - Gujranwala Electric Power Company</MenuItem>
                                                                <MenuItem value="13">FESCO - Faisalabad Electric Supply Company</MenuItem>
                                                                <MenuItem value="14">IESCO - Islamabad Electric Supply Company</MenuItem>
                                                                <MenuItem value="15">MEPCO - Multan Electric Power Company</MenuItem>
                                                                <MenuItem value="16">PESCO - Peshawar Electric Supply Company</MenuItem>
                                                                <MenuItem value="27">SEPCO - Sukkur Electric Power Company</MenuItem>
                                                                <MenuItem value="37">HESCO - Hyderabad Electric Supply Company</MenuItem>
                                                                <MenuItem value="48">QESCO - Quetta Electric Supply Company</MenuItem>
                                                                <MenuItem value="59">TESCO - Tribal Electric Supply Company</MenuItem>
                                                            </Select>
                                                            {openParentIndex !== null && (
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{
                                                                        background: 'linear-gradient(180deg, #FF6B35, #003971)',
                                                                        width: '100%',
                                                                        alignSelf: 'center',
                                                                        marginTop: '5px'
                                                                    }}
                                                                    onClick={handleBackToCompany}
                                                                    disabled={loading.parents || isLoading || statsLoading}
                                                                >
                                                                    Back to Company
                                                                </Button>
                                                            )}
                                                        </>
                                                    }
                                                    {
                                                        hierarchy == 2 &&
                                                        <Button variant="contained" sx={{ background: 'linear-gradient(180deg, #1DB6E8, #003971)', width: '100%', alignSelf: 'center' }} onClick={() => onPressCompany()}>Company</Button>

                                                    }
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    width: '100%',
                                                    padding: '5px 10px 0px 10px'
                                                }}>
                                                    {renderHierarchy(data123)}
                                                </div>
                                            </div>
                                        )
                                }


                            </div>
                    }
                </div>
            </div>

            < Dialog
                open={showComplaintForm}
                onClose={() => { onClose(); setSerachedTrackingId('') }}
                fullWidth={true}
                maxWidth="lg"

                className='alert-popups' >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#09669d' }}>
                    <p style={{ textAlign: 'center', width: '100%', color: 'white', display: 'flex', justifyContent: 'center', fontSize: "22px", padding: '20px' }}>
                        Complaint Details
                    </p>
                    <div style={{ padding: "15px" }}>
                        <img src={closeIconWhite} alt="close" style={{ width: 25, height: 25, cursor: 'pointer' }} onClick={() => { setShowComplaintForm(false); }} />
                    </div>
                </div>



                {
                    hierarchy == '52' ?
                        <>
                            <DialogContent style={{ backgroundColor: '#f2f3f5' }} >
                                {
                                    selectedMarker &&
                                    <>
                                        <Grid container spacing={2} >
                                            {/* Row 1 */}
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Complaint ID: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.EOpsTrackingId || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>CCMS ID: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.TicketNo || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Ref No.: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.RefNo || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Phone No.: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Mobile || "\u00A0"}
                                                </p>
                                            </Grid>
                                            {/* Row 2 */}
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Applicant Name: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Name || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Complaint Type: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.ComplaintType || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Registered @: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.RegisteredAt ? convertDatewithTime(selectedMarker.RegisteredAt) : "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Address: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Address.trim() || "\u00A0"}
                                                </p>
                                            </Grid>

                                            {/* Pending - Allocation Section */}
                                            {(selectedMarker.Status === 'Pending') && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Lineman: </p>
                                                        <Select style={{ backgroundColor: '#fff', borderRadius: '5px', border: '1px solid #ddd', height: 40 }} onChange={handleLinemanChange} displayEmpty fullWidth>
                                                            <MenuItem value="">Select</MenuItem>
                                                            {userIds.map((item) => (
                                                                <MenuItem value={item.userId} key={item.userId}>{toTitleCase(item.employeeName) + ' - ' + (item.employeeCode ? item.employeeCode : '-')}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={2}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Priority: </p>
                                                        <Select
                                                            style={{ backgroundColor: '#fff', borderRadius: '5px', border: '1px solid #ddd', height: 40 }}
                                                            onChange={handlePriority}
                                                            displayEmpty
                                                            fullWidth
                                                            value={Priority}
                                                        >
                                                            <MenuItem value="1">1</MenuItem>
                                                            <MenuItem value="2">2</MenuItem>
                                                            <MenuItem value="3">3</MenuItem>
                                                            <MenuItem value="4">4</MenuItem>
                                                            <MenuItem value="5">5</MenuItem>
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                        <Button variant="contained" sx={{ background: 'linear-gradient(180deg, #1DB6E8, #003971)', height: 40 }} fullWidth onClick={handleSubmitAssign}>Allocate</Button>
                                                    </Grid>
                                                </>
                                            )}

                                            {/* Allocated - Status Change Section */}
                                            {selectedMarker.Status === 'Allocated' && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned To:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{selectedMarker.UserFullName || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned At:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{convertDatewithTime(selectedMarker.AllocationDateTime) || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Change Status:</p>
                                                        <Select
                                                            label="Status"
                                                            displayEmpty
                                                            sx={{
                                                                height: '40px',
                                                                backgroundColor: '#fff',
                                                                border: '1px solid #ddd',
                                                                borderRadius: '5px',
                                                                '& .MuiOutlinedInput-root': {
                                                                    height: '40px',
                                                                    width: '100%'
                                                                },
                                                                width: '100%'
                                                            }}
                                                            value={status}
                                                            onChange={(event) => {
                                                                const selectedValue = event.target.value;
                                                                setStatus(selectedValue);
                                                                if (selectedValue === "") {
                                                                    setRemarkStatus("");
                                                                }
                                                            }}
                                                        >
                                                            <MenuItem value="">Select Status</MenuItem>
                                                            <MenuItem value="Resolved">Resolved</MenuItem>
                                                            <MenuItem value="onhold">Onhold</MenuItem>
                                                        </Select>
                                                    </Grid>
                                                    {status && (
                                                        <Grid item xs={12} sm={6} md={3}>
                                                            <p style={{ padding: '5px 0px', fontWeight: '500' }}>Remarks:</p>
                                                            <Select
                                                                label="Remarks"
                                                                defaultValue=""
                                                                sx={{
                                                                    height: "40px",
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '5px',
                                                                    "& .MuiOutlinedInput-root": {
                                                                        height: "40px",
                                                                    },
                                                                    width: "100%",
                                                                }}
                                                                onChange={(e) => onRemarkTypeChange(e.target.value)}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        sx: {
                                                                            maxHeight: 880,
                                                                            width: 400,
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {dropdownItems}
                                                            </Select>
                                                        </Grid>
                                                    )}

                                                    {remarkStatus === 'Other' && (
                                                        <Grid item xs={12} sm={6} md={3}>
                                                            <p style={{ padding: '5px 0px', fontWeight: '500' }}>Other:</p>
                                                            <TextField
                                                                variant="outlined"
                                                                value={otherComments}
                                                                onChange={(e) => setOtherComments(e.target.value)}
                                                                sx={{
                                                                    height: '40px',
                                                                    backgroundColor: '#fff',
                                                                    borderRadius: '5px',
                                                                    '& .MuiOutlinedInput-root': {
                                                                        height: '40px',
                                                                    },
                                                                    width: '100%'
                                                                }}
                                                            />
                                                        </Grid>
                                                    )}

                                                    <Grid item xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                        <Button variant="contained" sx={{ background: 'linear-gradient(180deg, #1DB6E8, #003971)', height: 40 }} fullWidth onClick={handleComplaintResolution}>
                                                            Submit
                                                        </Button>
                                                    </Grid>
                                                </>
                                            )}

                                            {/* On-Hold - Resume Section */}
                                            {(selectedMarker.Status !== 'Allocated' && selectedMarker.Status !== 'Pending' && (selectedMarker.Status === 'onhold' || selectedMarker.Status === 'Onhold')) && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned To:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{selectedMarker.UserFullName || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned At:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{convertDatewithTime(selectedMarker.AllocationDateTime) || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                        <Button variant="contained" sx={{ background: 'linear-gradient(180deg, #1DB6E8, #003971)', height: 40 }} fullWidth onClick={handleSubmitResume}>Resume</Button>
                                                    </Grid>
                                                </>
                                            )}

                                            {/* Other Statuses - Read Only */}
                                            {(selectedMarker.Status === "Resolved" || selectedMarker.Status === "Working" || selectedMarker.Status === "Reopen" || selectedMarker.Status === "New") && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned To:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{selectedMarker.UserFullName || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned At:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{convertDatewithTime(selectedMarker.AllocationDateTime) || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Source:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{selectedMarker.Source || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Status:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{selectedMarker.Status || "\u00A0"}</p>
                                                    </Grid>
                                                </>
                                            )}


                                            {
                                                powerComplaintsToDataGrid.length >= 1 &&

                                                    selectedMarker.Status != 'Allocated' ?
                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '5px' }}>
                                                        <div style={{ flex: 2 }}>
                                                            <h3 style={{ color: 'Black', padding: '10px' }}>
                                                                Already Allocated Complaints
                                                            </h3>
                                                            <div className='application-table' style={{ border: '1px solid #ccc', borderRadius: '5px' }}>
                                                                <div className='div-datagrid'>
                                                                    <BasicTable
                                                                        data={powerComplaintsToDataGrid}
                                                                        columns={tblColumns}
                                                                        sx={tableStyle}
                                                                        rowHeight={37.5}
                                                                        pageSize={18}
                                                                        rowsPerPageOptions={[18, 30, 60]}
                                                                        rowsPageOption={false}
                                                                        getRowStyle={(params) => {
                                                                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <></>
                                            }

                                        </Grid>
                                    </>
                                }
                            </DialogContent>
                        </> :
                        <>
                            <DialogContent style={{ backgroundColor: '#f2f3f5' }} >
                                {
                                    selectedMarker &&
                                    <>
                                        <Grid container spacing={2} >
                                            {/* Row 1 */}
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Complaint ID: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.EOpsTrackingId || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>CCMS ID: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.TicketNo || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Ref No.: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.RefNo || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Phone No.: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Mobile || "\u00A0"}
                                                </p>
                                            </Grid>
                                            {/* Row 2 */}
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Applicant Name: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Name || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Complaint Type: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.ComplaintType || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Registered @: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.RegisteredAt ? convertDatewithTime(selectedMarker.RegisteredAt) : "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Address: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Address || "\u00A0"}
                                                </p>
                                            </Grid>
                                            {/* Row 3 - Assigned Info */}
                                            {(selectedMarker.Status === "Resolved" || selectedMarker.Status === "Working" || selectedMarker.Status === "Allocated" || selectedMarker.Status === "Onhold" || selectedMarker.Status === "onhold" || selectedMarker.Status === "onHold" || selectedMarker.Status === "OnHold") && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned To:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{selectedMarker.UserFullName || "\u00A0"}</p>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned At:</p>
                                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>{convertDatewithTime(selectedMarker.AllocationDateTime) || "\u00A0"}</p>
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Status: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Status || "\u00A0"}
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Source: </p>
                                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px', whiteSpace: 'pre-wrap' }}>
                                                    {selectedMarker.Source || "\u00A0"}
                                                </p>
                                            </Grid>
                                        </Grid>
                                    </>
                                }
                            </DialogContent>
                        </>
                }
            </Dialog >

            <Dialog
                open={showPendingComplaint}
                onClose={() => setShowPendingComplaint(false)}
                fullWidth={true}
                maxWidth="xl"
                className='alert-popups' >
                <DialogTitle
                    sx={{
                        backgroundImage: 'linear-gradient(180deg, #1e52a7, #a0bbe7)',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: ' 1% 2%'
                    }}
                >
                    {/* Text on the left */}
                    <Box sx={{ textAlign: 'left', fontWeight: 'bold' }}>
                        {statsValue == '1'
                            ? 'Pending Complaint'
                            : statsValue == '2'
                                ? 'Allocated Complaint'
                                : statsValue == '3'
                                    ? 'Onhold Complaint'
                                    : statsValue == '4'
                                        ? 'Escalated Complaint'
                                        : statsValue == '5'
                                            ? 'Resolved Complaint'
                                            : statsValue == '6'
                                                ? 'Total Complaint'
                                                : statsValue == '7' && 'Working Complaint'}
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: '10px',
                        }}
                    >
                        <Box onClick={DownloadPdf} sx={{ height: '40px' }}>
                            <img src={pdf} alt="pdf" style={{ ...internalIconStyles, height: '100%' }} />
                        </Box>
                        <Box onClick={exportToExcel} sx={{ height: '40px' }}>
                            <img src={excel} alt="pdf" style={{ ...internalIconStyles, height: '100%' }} />
                        </Box>
                        <Box onClick={printPDF} sx={{ height: '40px' }}>
                            <img src={print} alt="pdf" style={{ ...internalIconStyles, height: '100%' }} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CloseIcon
                                id="clearPopup"
                                onClick={() => setShowPendingComplaint(false)}
                                sx={{ color: 'white', height: '50px' }}
                            />
                        </Box>
                    </Box>
                </DialogTitle>

                <DialogContent>
                    <Box className='form-box1'>
                        <div style={{ display: 'flex', flexDirection: "row" }}>
                            <Box className='application-table' style={{ marginRight: '10px' }}>
                                <div className='div-datagrid' >
                                    <div className='reports-container' >
                                        <div className='filter-fields'>

                                        </div>

                                    </div>
                                    <div className="table-container">
                                        <div id="pdf-table">
                                            <table className="table" ref={statsTableRef}>
                                                <thead>
                                                    <tr>
                                                        <th colSpan={statusNames.length + 1} style={{ fontSize: '20px', borderBottom: '2px solid white' }}>
                                                            {subdivisionName(hierarchy == 52 ? parseInt(code) : 15171, subDivisions) + " " + `Subdivision`}
                                                            {` - ${getCompanyName(code)}`}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                    </tr>
                                                </thead>
                                                <Box sx={{}}>
                                                    <Box >
                                                        <div ref={tableRef}>
                                                            <BasicTable
                                                                data={statsValue == '1' ? pendingStatsDetail : statsValue == '2' ? allocatedStatsDetail : statsValue == '3' ? onholdStatsDetail : statsValue == '4' ? escalatedStatsDetail : statsValue == '5' ? resolvedStatsDetail : statsValue == '6' ? allComplaintsStateDetail : statsValue == '7' && workingStatsDetail}
                                                                columns={statsValue == '1' ? tblPendingComplaints : statsValue == '2' ? tblAllocatedComplaints : statsValue == '3' ? tblOnHoldComplaints : statsValue == '4' ? tblEscalatedComplaints : statsValue == '5' ? tblResolvedComplaints : statsValue == '6' ? tblTotalComplaints : statsValue == '7' && tblWorkingComplaints}
                                                                sx={tableStyle}
                                                                rowHeight={37.5}
                                                                pageSize={18}
                                                                rowsPerPageOptions={[18, 30, 60]}
                                                                rowsPageOption={false}
                                                                getRowStyle={(params) => {
                                                                    return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                                                                }}

                                                            />
                                                        </div>
                                                    </Box>
                                                </Box>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </div>
                    </Box>
                </DialogContent>

            </Dialog >

            <Dialog open={openComplaintPopup} onClose={() => setOpenComplaintPopup(false)} fullWidth maxWidth="lg" sx={{ width: '1600px', maxWidth: '60%', margin: '0 auto' }}>
                {/* Dialog Header with Title and Close Icon */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(180deg, #1DB6E8, #003971)', padding: '0px 16px' }}>
                    <DialogTitle style={{ color: 'white', margin: 0 }}>Searched Result For  ( {SerachedTrackingId.length == '18' ? 'Tracking Id -' : ''} {SerachedTrackingId})</DialogTitle>
                    <IconButton onClick={() => setOpenComplaintPopup(false)} style={{ color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </div>

                {/* Dialog Content */}
                <DialogContent sx={{ backgroundColor: '#f3f5f6', maxHeight: '400px', overflowY: 'auto' }}>
                    <Box>
                        <TableContainer component={Paper} sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <Table
                                sx={{
                                    minWidth: 750,
                                    borderRadius: '8px',
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: 'white'
                                }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '8px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>Id.</TableCell>
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '8px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>Tracking Id.</TableCell>
                                        {/* <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '8px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>Ref No.</TableCell> */}
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '8px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>Name</TableCell>
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '8px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>Mobile No.</TableCell>
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '8px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>CNIC.</TableCell>
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '8px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>Complaint Type</TableCell>
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '10px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }}>Source</TableCell>
                                        <TableCell sx={{ fontFamily: 'Roboto-Medium', backgroundColor: '#f5f5f5', padding: '10px', textAlign: 'center', position: 'sticky', top: 0, zIndex: 1 }} >Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {multipleComplaints.map((complaint, index) => (
                                        <TableRow
                                            key={index}
                                            onClick={() => handleSelectComplaint(complaint)}
                                            sx={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }} // Ensures the line extends to the entire row
                                        >
                                            <TableCell sx={{ padding: '10px', textAlign: 'center' }}>{index + 1}</TableCell>
                                            <TableCell sx={{ padding: '10px', textAlign: 'center' }}>{complaint.EOpsTrackingId}</TableCell>
                                            {/* <TableCell sx={{ padding: '10px', textAlign: 'center' }}>{complaint.RefNo}</TableCell> */}
                                            <TableCell sx={{ padding: '10px', textAlign: 'center' }}>{complaint.Name}</TableCell>
                                            <TableCell sx={{ padding: '10px', textAlign: 'center' }}>{complaint.Mobile}</TableCell>
                                            <TableCell sx={{ padding: '10px', textAlign: 'center' }}>{complaint.CNIC}</TableCell>
                                            <TableCell sx={{ padding: '10px', textAlign: 'center' }}>{complaint.ComplaintType}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{complaint.Source}</TableCell>
                                            <TableCell
                                                sx={{
                                                    fontSize: "14px",
                                                    backgroundColor:
                                                        complaint.Status === "Resolved" ? "#bbf3de" :
                                                            complaint.Status === "Pending" ? "#ffe2e5" :
                                                                complaint.Status === "Allocated" ? "#bbf3ff" :
                                                                    complaint.Status === "Working" ? "#ebdbfe" :
                                                                        complaint.Status.toLowerCase().replace(/\s+/g, '') === "onhold" ? "#fef5c0" :
                                                                            complaint.Status === "New" ? "#333333" :
                                                                                complaint.Status === "Reopen" ? "#ffa75b" : "white",
                                                    color:
                                                        complaint.Status === "Resolved" ? "#24a574" :
                                                            complaint.Status === "Pending" ? "#c41728" :
                                                                complaint.Status === "Allocated" ? "#128299" :
                                                                    complaint.Status === "Working" ? "#8647d3" :
                                                                        complaint.Status.toLowerCase().replace(/\s+/g, '') === "onhold" ? "#c4a911" :
                                                                            complaint.Status === "New" ? "white" :
                                                                                complaint.Status === "Reopen" ? "white" : "white",
                                                    border: "none",
                                                    padding: "5px 10px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                    borderRadius: "10px",
                                                    marginTop: "20px",
                                                    marginRight: '10px',
                                                    animation: complaint.Status === "New" || complaint.Status === "Reopen" ? "zoomInOut 0.6s infinite alternate ease-in-out" : "none",
                                                    borderBottom: "1px solid rgba(224, 224, 224, 1)"
                                                }}
                                            >
                                                {complaint.Status}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* APMS Complaint Popup */}
            <Dialog
                open={showApmsPopup}
                onClose={handleCloseApmsPopup}
                fullWidth={true}
                maxWidth="lg"
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#09669d' }}>
                    <p style={{ textAlign: 'center', width: '100%', color: 'white', display: 'flex', justifyContent: 'center', fontSize: "22px", padding: '20px' }}>
                        APMS Complaint Details
                    </p>
                    <div style={{ padding: "15px" }}>
                        <img src={closeIconWhite} alt="close" style={{ width: 25, height: 25, cursor: 'pointer' }} onClick={handleCloseApmsPopup} />
                    </div>
                </div>
                <DialogContent style={{ backgroundColor: '#f2f3f5' }}>
                    {selectedApmsComplaint && (
                        <Grid container spacing={2}>
                            {/* Row 1 */}
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Tracking ID: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.eOpsTrackingId || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>APMS MSN: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.apmsMeterSerialNo || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Feeder Code: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.feederCode || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Status: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.status || "\u00A0"}
                                </p>
                            </Grid>
                            {/* Row 2 */}
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Transformer Name: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.transformerName || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Feeder Name: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.feederName || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Registered @: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.registeredAt ? convertDatewithTime(selectedApmsComplaint.registeredAt) : "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Registered By: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.registeredBy || "\u00A0"}
                                </p>
                            </Grid>
                            {/* Row 3 */}
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Category: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.complaintCategoryName || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Complaint Type: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.complaintTypeName || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Source: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.source || "\u00A0"}
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <p style={{ padding: '5px 0px', fontWeight: '500' }}>Description: </p>
                                <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                    {selectedApmsComplaint.description || "\u00A0"}
                                </p>
                            </Grid>

                            {/* Pending - Allocation Section */}
                            {selectedApmsComplaint.status === 'Pending' && (
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Lineman: </p>
                                        <Select
                                            style={{ backgroundColor: '#fff', borderRadius: '5px', border: '1px solid #ddd', height: 40 }}
                                            value={apmsLineman}
                                            onChange={(e) => setApmsLineman(e.target.value)}
                                            displayEmpty
                                            fullWidth
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            {userIds.map((item) => (
                                                <MenuItem value={item.userId} key={item.userId}>
                                                    {toTitleCase(item.employeeName) + ' - ' + (item.employeeCode ? item.employeeCode : '-')}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Button
                                            variant="contained"
                                            style={{ backgroundColor: '#09669d', color: 'white', height: 40 }}
                                            fullWidth
                                            onClick={async () => {
                                                if (!apmsLineman) {
                                                    alert('Please select a lineman');
                                                    return;
                                                }
                                                setViewBackdrop(true);
                                                const myHeaders = new Headers();
                                                myHeaders.append("Authorization", token);
                                                myHeaders.append("Content-Type", "application/json");

                                                const raw = JSON.stringify({
                                                    "applicationId": selectedApmsComplaint.eOpsTrackingId,
                                                    "allocatedTo": apmsLineman
                                                });

                                                const requestOptions = {
                                                    method: "POST",
                                                    headers: myHeaders,
                                                    body: raw,
                                                    redirect: "follow"
                                                };

                                                try {
                                                    const response = await fetch(cfpBaseUrl + "apms/allocateComplaint", requestOptions);
                                                    const result = await response.json();
                                                    console.log('APMS Allocation Response:', result);

                                                    if (response.status === 200 || result.status === "200") {
                                                        setViewBackdrop(false);
                                                        handleCloseApmsPopup();
                                                        setApmsSuccessMessage('APMS complaint allocated successfully');
                                                        setShowApmsSuccessDialog(true);
                                                        // Refresh APMS complaints list
                                                        const subDivCodeToUse = subDivision || (roleTypeId == 1 || code == "10" || code == 10 ? disco : code);
                                                        const dateObject = new Date();
                                                        const formattedDate = dateObject.toISOString().split('T')[0];

                                                        const refreshHeaders = new Headers();
                                                        refreshHeaders.append("Authorization", token);
                                                        refreshHeaders.append("Content-Type", "application/json");

                                                        const refreshRaw = JSON.stringify({
                                                            "pageNumber": "1",
                                                            "pageSize": "100",
                                                            "officeCode": subDivCodeToUse,
                                                            "dateFrom": "",
                                                            "dateTo": formattedDate,
                                                            "status":""
                                                        });

                                                        const refreshOptions = {
                                                            method: "POST",
                                                            headers: refreshHeaders,
                                                            body: refreshRaw,
                                                            redirect: "follow"
                                                        };

                                                        const refreshResponse = await fetch(cfpBaseUrl + "apms/getAllAPMSComplaint", refreshOptions);
                                                        const refreshResult = await refreshResponse.json();

                                                        if (refreshResult.status === "200" && refreshResult.data) {
                                                            setApmsComplaints(refreshResult.data);
                                                            const pending = refreshResult.data.filter(c => c.status === 'Pending').length;
                                                            const allocated = refreshResult.data.filter(c => c.status === 'Allocated').length;
                                                            const onhold = refreshResult.data.filter(c => c.status === 'Onhold' || c.status === 'OnHold' || c.status === 'onhold').length;
                                                            setApmsPendingStats(pending);
                                                            setApmsAllocatedStats(allocated);
                                                            setApmsOnholdStats(onhold);
                                                        }
                                                    } else {
                                                        setViewBackdrop(false);
                                                        alert(result.message || 'Failed to allocate APMS complaint');
                                                    }
                                                } catch (error) {
                                                    console.error('Error allocating APMS complaint:', error);
                                                    setViewBackdrop(false);
                                                    alert('Error allocating APMS complaint. Please try again.');
                                                }
                                            }}
                                        >
                                            ALLOCATE
                                        </Button>
                                    </Grid>
                                </>
                            )}

                            {/* Allocated Complaint - Status Change Section */}
                            {selectedApmsComplaint.status === 'Allocated' && (
                                <>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned To: </p>
                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                            {selectedApmsComplaint.allocatedToName || selectedApmsComplaint.allocatedTo || "\u00A0"}
                                        </p>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned At: </p>
                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                            {selectedApmsComplaint.allocatedAt ? convertDatewithTime(selectedApmsComplaint.allocatedAt) : "\u00A0"}
                                        </p>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Change Status: </p>
                                        <Select
                                            style={{ backgroundColor: '#fff', borderRadius: '5px', border: '1px solid #ddd', height: 40 }}
                                            value={apmsStatus}
                                            onChange={(e) => setApmsStatus(e.target.value)}
                                            displayEmpty
                                            fullWidth
                                        >
                                            <MenuItem value="">Select Status</MenuItem>
                                            <MenuItem value="Resolved">Resolved</MenuItem>
                                            <MenuItem value="Onhold">Onhold</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Lineman Remarks: <span style={{ color: 'red' }}>*</span></p>
                                        <TextField
                                            variant="outlined"
                                            value={apmsLinemanRemarks}
                                            onChange={(e) => {
                                                setApmsLinemanRemarks(e.target.value);
                                                if (e.target.value.trim() !== '') {
                                                    setApmsRemarksError('');
                                                }
                                            }}
                                            placeholder="Enter remarks"
                                            error={!!apmsRemarksError}
                                            sx={{
                                                height: '40px',
                                                backgroundColor: '#fff',
                                                borderRadius: '5px',
                                                '& .MuiOutlinedInput-root': {
                                                    height: '40px',
                                                },
                                                width: '100%'
                                            }}
                                        />
                                        {apmsRemarksError && <p style={{ color: 'red', fontSize: '12px', margin: '4px 0 0 0' }}>{apmsRemarksError}</p>}
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Button
                                            variant="contained"
                                            style={{ backgroundColor: '#09669d', color: 'white', height: 40 }}
                                            fullWidth
                                            onClick={async () => {
                                                if (!apmsStatus) {
                                                    alert('Please select a status');
                                                    return;
                                                }
                                                if (!apmsLinemanRemarks || apmsLinemanRemarks.trim() === '') {
                                                    setApmsRemarksError('Please enter lineman remarks');
                                                    return;
                                                }
                                                setApmsRemarksError('');
                                                setViewBackdrop(true);
                                                const myHeaders = new Headers();
                                                myHeaders.append("Authorization", token);
                                                myHeaders.append("Content-Type", "application/json");

                                                const raw = JSON.stringify({
                                                    "applicationId": selectedApmsComplaint.eOpsTrackingId,
                                                    "status": apmsStatus,
                                                    "linemanRemarks": apmsLinemanRemarks
                                                });

                                                const requestOptions = {
                                                    method: "POST",
                                                    headers: myHeaders,
                                                    body: raw,
                                                    redirect: "follow"
                                                };

                                                try {
                                                    const response = await fetch(cfpBaseUrl + "apms/updateComplaint", requestOptions);
                                                    const result = await response.json();
                                                    console.log('APMS Status Update Response:', result);

                                                    if (response.status === 200 || result.status === "200") {
                                                        setViewBackdrop(false);
                                                        handleCloseApmsPopup();
                                                        setApmsSuccessMessage(apmsStatus === 'Resolved' ? 'APMS complaint resolved successfully' : 'APMS complaint marked on-hold successfully');
                                                        setShowApmsSuccessDialog(true);
                                                        // Refresh APMS complaints list
                                                        window.dispatchEvent(new CustomEvent('apmsComplaintSubmitted'));
                                                    } else {
                                                        setViewBackdrop(false);
                                                        alert(result.message || 'Failed to update APMS complaint status');
                                                    }
                                                } catch (error) {
                                                    console.error('Error updating APMS complaint status:', error);
                                                    setViewBackdrop(false);
                                                    alert('Error updating APMS complaint status. Please try again.');
                                                }
                                            }}
                                        >
                                            SUBMIT
                                        </Button>
                                    </Grid>
                                </>
                            )}

                            {/* On-Hold Complaint - Resume Section */}
                            {(selectedApmsComplaint.status === 'Onhold' || selectedApmsComplaint.status === 'OnHold' || selectedApmsComplaint.status === 'onhold') && (
                                <>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned To: </p>
                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                            {selectedApmsComplaint.allocatedToName || selectedApmsComplaint.allocatedTo || "\u00A0"}
                                        </p>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <p style={{ padding: '5px 0px', fontWeight: '500' }}>Assigned At: </p>
                                        <p style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #ddd', minHeight: '20px' }}>
                                            {selectedApmsComplaint.allocatedAt ? convertDatewithTime(selectedApmsComplaint.allocatedAt) : "\u00A0"}
                                        </p>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Button
                                            variant="contained"
                                            style={{ backgroundColor: '#09669d', color: 'white', height: 40 }}
                                            fullWidth
                                            onClick={async () => {
                                                setViewBackdrop(true);
                                                const myHeaders = new Headers();
                                                myHeaders.append("Authorization", token);
                                                myHeaders.append("Content-Type", "application/json");

                                                const raw = JSON.stringify({
                                                    "applicationId": selectedApmsComplaint.eOpsTrackingId,
                                                    "status": "Allocated"
                                                });

                                                const requestOptions = {
                                                    method: "POST",
                                                    headers: myHeaders,
                                                    body: raw,
                                                    redirect: "follow"
                                                };

                                                try {
                                                    const response = await fetch(cfpBaseUrl + "apms/updateComplaint", requestOptions);
                                                    const result = await response.json();
                                                    console.log('APMS Resume Response:', result);

                                                    if (response.status === 200 || result.status === "200") {
                                                        setViewBackdrop(false);
                                                        handleCloseApmsPopup();
                                                        setApmsSuccessMessage('APMS complaint resumed successfully');
                                                        setShowApmsSuccessDialog(true);
                                                        // Refresh APMS complaints list
                                                        window.dispatchEvent(new CustomEvent('apmsComplaintSubmitted'));
                                                    } else {
                                                        setViewBackdrop(false);
                                                        alert(result.message || 'Failed to resume APMS complaint');
                                                    }
                                                } catch (error) {
                                                    console.error('Error resuming APMS complaint:', error);
                                                    setViewBackdrop(false);
                                                    alert('Error resuming APMS complaint. Please try again.');
                                                }
                                            }}
                                        >
                                            RESUME
                                        </Button>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    )}
                </DialogContent>
            </Dialog>

            {/* APMS Success Dialog */}
            <Dialog
                open={showApmsSuccessDialog}
                onClose={() => setShowApmsSuccessDialog(false)}
                maxWidth="xs"
                fullWidth
            >
                <div style={{ backgroundColor: '#4CAF50', padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ color: 'white', fontSize: '18px', fontWeight: '500' }}>Success</span>
                    <span style={{ color: 'white', cursor: 'pointer', fontSize: '20px' }} onClick={() => setShowApmsSuccessDialog(false)}>×</span>
                </div>
                <DialogContent style={{ textAlign: 'center', padding: '30px' }}>
                    <div style={{ fontSize: '50px', color: '#333', marginBottom: '15px' }}>✓</div>
                    <p style={{ fontSize: '16px', color: '#333' }}>{apmsSuccessMessage}</p>
                </DialogContent>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '0 20px 20px' }}>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: '#4CAF50', color: 'white', minWidth: '100px' }}
                        onClick={() => setShowApmsSuccessDialog(false)}
                    >
                        OK
                    </Button>
                </div>
            </Dialog>

            <Dialog
                open={openComplaintError}
                onClose={() => { setOpenComplaintError(false); setSerachedTrackingId('') }}
                fullWidth={true}
                maxWidth="md"
                className="alert-popups"
            >
                <div style={{ background: "linear-gradient(180deg, #1DB6E8, #003971)", display: "flex", justifyContent: 'space-between' }}>
                    <div>
                        <p
                            style={{
                                textAlign: "center",
                                color: "white",
                                display: "flex",
                                justifyContent: "center",
                                fontSize: "22px",
                                padding: "20px",
                            }}
                        >

                            Searched Complaint Detail - ({SerachedTrackingId})
                        </p>
                    </div>
                    <div style={{ padding: "15px" }}>
                        <img
                            src={closeIconWhite}
                            style={{ width: 25, height: 25, cursor: "pointer" }}
                            onClick={() => { setOpenComplaintError(false); setSerachedTrackingId('') }}
                            alt="Close"
                        />
                    </div>
                </div>
                <DialogContent >
                    {/* <Typography color="red">{complaintNotFoundMessage}</Typography> */}
                    <p style={{ fontSize: '20px', color: 'red', textAlign: 'center' }}>
                        {complaintNotFoundMessage}
                    </p>
                </DialogContent>
            </Dialog>

            {/* Idle Linemen Popup */}
            <Dialog
                open={showIdleLinemanPopup}
                onClose={() => setShowIdleLinemanPopup(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <div style={{ background: 'linear-gradient(135deg, #7c3aed, #5b21b6)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px' }}>
                    <span style={{ color: 'white', fontSize: '18px', fontWeight: 600 }}>
                        Idle Linemen (No Task Assigned)
                    </span>
                    <IconButton onClick={() => setShowIdleLinemanPopup(false)} style={{ color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContent sx={{ backgroundColor: '#f8fafc', padding: '16px' }}>
                    {(() => {
                        // Get all idle linemen (only those with valid 5-digit subdivision code)
                        const allIdleLinemen = userIds.filter(u => {
                            const hasComplaints = complaints?.some(c => c.AllocatedTo === u.userId && c.Status !== 'Resolved');
                            const subDivCode = u.subDivisionCode || u.subdivisionCode;
                            const hasValidSubdiv = subDivCode && String(subDivCode).length === 5;
                            return !hasComplaints && hasValidSubdiv;
                        });

                        // Get unique circles, divisions, subdivisions for filters
                        const circleOptions = [];
                        const divisionOptions = [];
                        const subdivOptions = [];
                        const circleSet = new Set();
                        const divisionSet = new Set();
                        const subdivSet = new Set();

                        allIdleLinemen.forEach(lineman => {
                            const subDivCode = lineman.subDivisionCode || lineman.subdivisionCode;
                            if (subDivCode) {
                                const cCode = String(subDivCode).slice(0, 3);
                                const dCode = String(subDivCode).slice(0, 4);
                                if (!circleSet.has(cCode)) {
                                    circleSet.add(cCode);
                                    circleOptions.push({ code: cCode, name: getCircleName(parseInt(cCode), subDivisions) || cCode });
                                }
                                if (!divisionSet.has(dCode) && (!idleLinemanCircleFilter || cCode === idleLinemanCircleFilter)) {
                                    divisionSet.add(dCode);
                                    divisionOptions.push({ code: dCode, name: getDivisionName(parseInt(dCode), subDivisions) || dCode });
                                }
                                if (!subdivSet.has(subDivCode) && (!idleLinemanCircleFilter || cCode === idleLinemanCircleFilter) && (!idleLinemanDivisionFilter || dCode === idleLinemanDivisionFilter)) {
                                    subdivSet.add(subDivCode);
                                    subdivOptions.push({ code: subDivCode, name: subdivisionName(parseInt(subDivCode), subDivisions) || subDivCode });
                                }
                            }
                        });

                        // Apply filters
                        let filteredLinemen = allIdleLinemen.filter(lineman => {
                            const subDivCode = lineman.subDivisionCode || lineman.subdivisionCode;
                            const cCode = subDivCode ? String(subDivCode).slice(0, 3) : '';
                            const dCode = subDivCode ? String(subDivCode).slice(0, 4) : '';

                            // Circle filter
                            if (idleLinemanCircleFilter && cCode !== idleLinemanCircleFilter) return false;
                            // Division filter
                            if (idleLinemanDivisionFilter && dCode !== idleLinemanDivisionFilter) return false;
                            // Subdivision filter
                            if (idleLinemanSubdivFilter && String(subDivCode) !== idleLinemanSubdivFilter) return false;
                            // Search filter
                            if (idleLinemanSearch) {
                                const search = idleLinemanSearch.toLowerCase();
                                const name = (lineman.employeeName || '').toLowerCase();
                                const code = (lineman.employeeCode || '').toLowerCase();
                                if (!name.includes(search) && !code.includes(search)) return false;
                            }
                            return true;
                        });

                        // Group by circle code
                        const groupedByCircle = {};
                        filteredLinemen.forEach(lineman => {
                            const subDivCode = lineman.subDivisionCode || lineman.subdivisionCode;
                            const circleCode = subDivCode ? String(subDivCode).slice(0, 3) : 'unknown';
                            if (!groupedByCircle[circleCode]) {
                                groupedByCircle[circleCode] = [];
                            }
                            groupedByCircle[circleCode].push(lineman);
                        });

                        const sortedCircleCodes = Object.keys(groupedByCircle).sort();

                        return (
                            <>
                                {/* Filters Row */}
                                <div style={{ display: 'flex', gap: '10px', marginBottom: '12px', flexWrap: 'wrap' }}>
                                    {/* Search */}
                                    <input
                                        type="text"
                                        placeholder="Search by name or code..."
                                        value={idleLinemanSearch}
                                        onChange={(e) => setIdleLinemanSearch(e.target.value)}
                                        style={{
                                            flex: 1,
                                            minWidth: '150px',
                                            padding: '8px 12px',
                                            borderRadius: '6px',
                                            border: '1px solid #e2e8f0',
                                            fontSize: '12px',
                                            outline: 'none'
                                        }}
                                    />
                                    {/* Circle Filter */}
                                    <select
                                        value={idleLinemanCircleFilter}
                                        onChange={(e) => {
                                            setIdleLinemanCircleFilter(e.target.value);
                                            setIdleLinemanDivisionFilter('');
                                            setIdleLinemanSubdivFilter('');
                                        }}
                                        style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '12px', minWidth: '120px' }}
                                    >
                                        <option value="">All Circles</option>
                                        {circleOptions.sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''))).map(c => (
                                            <option key={c.code} value={c.code}>{c.name}</option>
                                        ))}
                                    </select>
                                    {/* Division Filter */}
                                    <select
                                        value={idleLinemanDivisionFilter}
                                        onChange={(e) => {
                                            setIdleLinemanDivisionFilter(e.target.value);
                                            setIdleLinemanSubdivFilter('');
                                        }}
                                        style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '12px', minWidth: '120px' }}
                                        disabled={!idleLinemanCircleFilter}
                                    >
                                        <option value="">All Divisions</option>
                                        {divisionOptions.sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''))).map(d => (
                                            <option key={d.code} value={d.code}>{d.name}</option>
                                        ))}
                                    </select>
                                    {/* Subdivision Filter */}
                                    <select
                                        value={idleLinemanSubdivFilter}
                                        onChange={(e) => setIdleLinemanSubdivFilter(e.target.value)}
                                        style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '12px', minWidth: '120px' }}
                                        disabled={!idleLinemanDivisionFilter}
                                    >
                                        <option value="">All Subdivisions</option>
                                        {subdivOptions.sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''))).map(s => (
                                            <option key={s.code} value={s.code}>{s.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Stats */}
                                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontSize: '13px', color: '#64748b' }}>
                                        Showing: <strong style={{ color: '#7c3aed' }}>{filteredLinemen.length}</strong> of {allIdleLinemen.length} Idle Linemen
                                        {sortedCircleCodes.length > 0 && (
                                            <span style={{ marginLeft: '10px', fontSize: '11px' }}>
                                                ({sortedCircleCodes.length} Circles)
                                            </span>
                                        )}
                                    </span>
                                    {(idleLinemanSearch || idleLinemanCircleFilter) && (
                                        <button
                                            onClick={() => {
                                                setIdleLinemanSearch('');
                                                setIdleLinemanCircleFilter('');
                                                setIdleLinemanDivisionFilter('');
                                                setIdleLinemanSubdivFilter('');
                                            }}
                                            style={{
                                                padding: '4px 10px',
                                                fontSize: '11px',
                                                background: '#ef4444',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Clear Filters
                                        </button>
                                    )}
                                </div>

                                <TableContainer component={Paper} sx={{ maxHeight: '350px', overflowY: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 600, backgroundColor: '#f1f5f9', color: '#334155', padding: '10px' }}>#</TableCell>
                                                <TableCell sx={{ fontWeight: 600, backgroundColor: '#f1f5f9', color: '#334155', padding: '10px' }}>Name</TableCell>
                                                <TableCell sx={{ fontWeight: 600, backgroundColor: '#f1f5f9', color: '#334155', padding: '10px' }}>Code</TableCell>
                                                <TableCell sx={{ fontWeight: 600, backgroundColor: '#f1f5f9', color: '#334155', padding: '10px' }}>Subdivision</TableCell>
                                                <TableCell sx={{ fontWeight: 600, backgroundColor: '#f1f5f9', color: '#334155', padding: '10px', textAlign: 'center' }}>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedCircleCodes.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5} sx={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                                        No linemen found matching the filters
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                sortedCircleCodes.map((circleCodeKey) => {
                                                    const circleLinemen = groupedByCircle[circleCodeKey];
                                                    const circleNameStr = getCircleName(parseInt(circleCodeKey), subDivisions) || circleCodeKey;
                                                    return (
                                                        <React.Fragment key={circleCodeKey}>
                                                            {/* Circle Header Row */}
                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={5}
                                                                    sx={{
                                                                        background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                                                                        color: 'white',
                                                                        fontWeight: 600,
                                                                        fontSize: '11px',
                                                                        padding: '8px 10px'
                                                                    }}
                                                                >
                                                                    {circleNameStr} Circle
                                                                    <span style={{
                                                                        marginLeft: '8px',
                                                                        background: 'rgba(255,255,255,0.2)',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '8px',
                                                                        fontSize: '9px'
                                                                    }}>
                                                                        {circleLinemen.length}
                                                                    </span>
                                                                </TableCell>
                                                            </TableRow>
                                                            {/* Linemen Rows */}
                                                            {circleLinemen.map((lineman, index) => {
                                                                const subDivCode = lineman.subDivisionCode || lineman.subdivisionCode;
                                                                const subDivName = subDivCode ? subdivisionName(parseInt(subDivCode), subDivisions) : '-';
                                                                return (
                                                                    <TableRow key={lineman.userId || index} sx={{ '&:hover': { backgroundColor: '#f0f4ff' } }}>
                                                                        <TableCell sx={{ padding: '6px 10px', color: '#64748b', fontSize: '11px' }}>{index + 1}</TableCell>
                                                                        <TableCell sx={{ padding: '6px 10px', fontWeight: 500, color: '#1e293b', fontSize: '11px' }}>
                                                                            {lineman.employeeName || 'Unknown'}
                                                                        </TableCell>
                                                                        <TableCell sx={{ padding: '6px 10px', color: '#64748b', fontSize: '11px' }}>
                                                                            {lineman.employeeCode || '-'}
                                                                        </TableCell>
                                                                        <TableCell sx={{ padding: '6px 10px', color: '#64748b', fontSize: '11px' }}>
                                                                            {subDivName || subDivCode || '-'}
                                                                        </TableCell>
                                                                        <TableCell sx={{ padding: '6px 10px', textAlign: 'center' }}>
                                                                            <span style={{
                                                                                background: '#fef3c7',
                                                                                color: '#92400e',
                                                                                padding: '2px 8px',
                                                                                borderRadius: '10px',
                                                                                fontSize: '9px',
                                                                                fontWeight: 600
                                                                            }}>
                                                                                Idle
                                                                            </span>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </React.Fragment>
                                                    );
                                                })
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        );
                    })()}
                </DialogContent>
            </Dialog>

            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default ComplaintsGIS;